$(document).ready(function () {

  if ( window.location.href.indexOf("whisky-subscription-the-advanced-membership") > -1 || window.location.href.indexOf("whisky-subscription-the-explorer-membership") > -1 ){
    
    const checkInterval = setInterval(() => { 
        const appstleWidget = document.querySelectorAll("#appstle_subscription_widget0");

        if (appstleWidget.length > 0) {
            document.querySelectorAll(".membership-buy-btn").forEach(btn => {
            btn.style.display = "block";
            });

            document.querySelector(".membership-btn-wrapper .loader_icon").style.display = "none";

            clearInterval(checkInterval);
        }
    }, 500);

    const intervalId = setInterval(function () {
    const sellingPlanWrapper = document.querySelector('.appstleRadioSellingPlanWrapper');
    if (!sellingPlanWrapper) return;
  
    const radioWrappers = sellingPlanWrapper.querySelectorAll('.appstle-radio-wrapper');
  
    if (radioWrappers.length > 3) {
      clearInterval(intervalId);
  
      const preorderWrapper = document.createElement('div');
      preorderWrapper.className = 'appstle-preorder-wrapper';
      preorderWrapper.style.display = 'none';
  
      preorderWrapper.appendChild(radioWrappers[1]);
      preorderWrapper.appendChild(radioWrappers[2]);
      preorderWrapper.appendChild(radioWrappers[3]);
  
      radioWrappers[0].after(preorderWrapper);
  
      const checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.id = 'togglePreorder';
      checkbox.checked = false;
  
      const label = document.createElement('label');
      label.setAttribute('for', 'togglePreorder');
      label.textContent = 'Prepay for subscription';
      label.style.marginRight = '10px';
  
      const checkboxWrapper = document.createElement('div');
      checkboxWrapper.classList.add("prepaid-order-checkbox-wrapper");
      checkboxWrapper.style.margin = '10px 0 0';
      checkboxWrapper.appendChild(checkbox);
      checkboxWrapper.appendChild(label);
  
      radioWrappers[0].after(checkboxWrapper);

      const subscriptionAttribute = document.createElement('input');
      subscriptionAttribute.type = 'hidden';
      subscriptionAttribute.name = 'properties[Delivered every 1 month]';
      subscriptionAttribute.value = '';
      subscriptionAttribute.classList.add("subscription_delivery_property");
      radioWrappers[0].after(subscriptionAttribute);

      checkbox.addEventListener('change', function () {
        preorderWrapper.style.display = this.checked ? 'block' : 'none';
      });
    }
  }, 500);
  }

  if (window.location.href.indexOf("gifts-onboarding") > -1) {

    $.getJSON('/cart.js', function(cart) {
        let variantIdsToCheckGift = []; // Add more variant IDs as needed
        let productInCartGift = cart.items.some(item => variantIdsToCheckGift.includes(item.id));
    
        if (productInCartGift) {
            let popup_htmlGift = `<div class="cart-popup-error">
                                <div class="popup-content-wrapper">
                                  <div class="popup-content">
                                    <p>Please checkout individually for multiple subscription, gift card or redemption orders.</p>
                                    <p>Must have at most 1 of subscription - 1 max per checkout.</p>
                                  </div>
                                  <div class="popup-cta">
                                    <span class="close-popup-gift">OK</span>
                                  </div>
                                </div>
                              </div>`;
          $('#MainContent').append(popup_htmlGift);
          $('html').addClass('no-scroll');
        }else{
          setTimeout(function (){
            $('.checkout__gift_btn').css('opacity', 1);
            // $('.checkout__gift_btn').css('pointer-events', 'auto');
            // $('.checkout__gift_btn img').css('display', 'none');
    
            if (window.location.hash === "#3-month-giftcard-whisky-explorer") {
              document.querySelector('.subscription-onboarding-footer .checkout__gift_btn').setAttribute('data-variant-id', 39992897699888);
            } else if (window.location.hash === "#6-month-giftcard-whisky-explorer"){
              document.querySelector('.subscription-onboarding-footer .checkout__gift_btn').setAttribute('data-variant-id', 39992897732656);
            } else if (window.location.hash === "#12-month-giftcard-whisky-explorer"){
              document.querySelector('.subscription-onboarding-footer .checkout__gift_btn').setAttribute('data-variant-id', 39992897830960);
            } else if (window.location.hash === "#3-month-giftcard-whisky-advanced"){
              document.querySelector('.subscription-onboarding-footer .checkout__gift_btn').setAttribute('data-variant-id', 39997424894000);
            } else if (window.location.hash === "#6-month-giftcard-whisky-advanced"){
              document.querySelector('.subscription-onboarding-footer .checkout__gift_btn').setAttribute('data-variant-id', 39997424926768);
            } else if (window.location.hash === "#6-month-giftcard-whisky-advanced"){
              document.querySelector('.subscription-onboarding-footer .checkout__gift_btn').setAttribute('data-variant-id', 39997424861232);
            }
          }, 1500);
        }
    });

    $('body').on('click', '.cart-popup-error .popup-cta .close-popup-gift', function(){
      history.go(-1);
    });
  }

    // Image parallax.
    var $animation_elements = $('.section-half-pane .section__image');
    var $window = $(window);
    function check_if_in_view() {
        var window_height = $window.height();
        var window_top_position = $window.scrollTop();
        var window_bottom_position = (window_top_position + window_height);
        $.each($animation_elements, function () {
            var $element = $(this);
            var small_image_height = $element.find('.section__image-add').outerHeight();
            var element_height = $element.outerHeight() - small_image_height;
            var element_top_position = $element.offset().top;
            var element_bottom_position = (element_top_position + element_height);
            var limit = 0;
            if ($(window).width() < 768) {
                var top_limit = $element.outerHeight() - 100;
            } else {
                var top_limit = $element.outerHeight() - 177;
            }

            //check to see if this current container is within viewport
            if (element_bottom_position <= window_bottom_position) {
                var position = limit + ((window_bottom_position - element_bottom_position) * 0.35)
                if ((limit < position) && (position < top_limit)) {
                    $element.find('.section__image-add').css("bottom", position);
                }
            }
        });
    }
    $window.on('scroll resize', check_if_in_view);
    $window.trigger('scroll');

    //side-cart

    //spinner
    $(document).on("click", ".spinner .plus", function () {
        var target = $(this).siblings("input");
        var value = parseInt(target.val()) + 1;
        target.val(value);
        $('#side_cart .update').trigger("click");
        if ($('.section-cart-page')) {
            $('.section-cart-page .btn--update').trigger("click");
        }
    });
    $(document).on("click", ".spinner .min", function () {
        var target = $(this).siblings("input");
        var value = parseInt(target.val());
        if (value > 0) {
            var value = value - 1;
            target.val(value);
        }
        $('#side_cart .update').trigger("click");
        if ($('.section-cart-page')) {
            $('.section-cart-page .btn--update').trigger("click");
        }
    });

    //ajax cart
    $(document).on("submit", ".ajaxCart", function (e) {
        e.preventDefault();
        var $form = $(this);
        if ($('.messageChecked').length > 0 || $('.ribbonChecked').length > 0 ) {
            var isValid = true;
            if ($('.messageChecked').length > 0 ) {
                isValid = formValidation();
            }
            if(isValid === false){
                $('.form__message--error').text("Please provide all details for the gift message");
            }else{
                $('.form__message--error').text("");
                ajaxCartGiftAddon($form);
            }
        } else {
            ajaxCart($form);
        }
    });

    //mini cart open
    var miniCartOpen = function miniCartOpen() {
        if ($("#side_cart").hasClass("active")) {
            $("#side_cart").removeClass("active");
            // $("html").removeClass("overflow_hidden");
            // $("body").removeClass("overflow_hidden");
            $(".black_bg").fadeOut();
            $(".mfp-close").trigger("click");
            $.fn.sideCartUpsellHeightChange();
        }
        else {
                $("#side_cart").addClass("active");
                // $("html").addClass("overflow_hidden");
                // $("body").addClass("overflow_hidden");
                $(".black_bg").fadeIn();
                $(".mfp-close").trigger("click");
                $.fn.sideCartUpsellHeightChange();
        }
    };
    $('.side_cart').on('click', function (e) {
        if ($("#side_cart").hasClass("active")) {
            $("#side_cart").removeClass("active");
            // $("html").removeClass("overflow_hidden");
            // $("body").removeClass("overflow_hidden");
            $(".black_bg").fadeOut();
            $.fn.sideCartUpsellHeightChange();
        }
        else {
            $("#side_cart").addClass("active");
            // $("html").addClass("overflow_hidden");
            // $("body").addClass("overflow_hidden");
            $(".black_bg").fadeIn();
            $.fn.sideCartUpsellHeightChange();
        }
    });

    $(document).on("click", ".black_bg, #side_cart .close", function () {
        $(".black_bg").fadeOut();
        $("#side_cart").removeClass("active");
        $("html").removeClass("overflow_hidden");
        $("body").removeClass("overflow_hidden");
    });

    //mini cart update
    $(document).on("click", "#side_cart .update", function () {
        var form = $("#side_cart form");
        if (form.find(".items").length == 0) {
            $("#side_cart .no_data").fadeIn();
        }
        else {
            $("#side_cart .no_data").fadeOut();
            miniCartUpdate(form);
        }
    });

    $(document).on("click", "#side_cart .checkout", function () {
        var form = $("#side_cart form");
        var checkout = $(this).attr("data-checkout");
        if (form.find(".items").length == 0) {
            $("#side_cart .no_data").fadeIn();
        }
        else {
            $("#side_cart .no_data").fadeOut();
            if (cn(checkout)) {
                $(this).text("Updating");
            }
            else {
                $(this).text("Please wait");
            }
            if ($(this).attr("data-subscription") === 'true') {
                return
            } else {
                miniCartUpdate(form, checkout);
            }
        }
    });

    //mini cart remove product
    $(document).on("click", "#side_cart .remove", function () {
        $(this).text("Removing...");
        var input = $(this).parent().find("input");
        input.val(0);
        var form = $("#side_cart form");
        var remove = $(this);
        miniCartUpdate(form);
    });

    var ajaxCart = function ajaxCart(form) {
        var qty = $("#quantity", form).val();
        var data = form.serialize();
        var params = {
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function (line_item) {
                updateCartCount(qty);
                if ($(".side_cart").length == 0) {
                    miniCartInit(qty);
                    // $('#side_cart').find('.no_data').show();
                }
                else {
                    miniCartInit("open");
                }
            },
            error: function (XMLHttpRequest, textStatus) {
                var error = JSON.parse((XMLHttpRequest.responseText)).description;
                var error_popup = $("<div id='quick_error'></div>");
                error_popup.html("");
                error_popup.append("<h6>" + error + "</h6>");
            }
        }
        jQuery.ajax(params);
    };

    var ajaxCartGiftAddon = function ajaxCart(form) {
        Shopify.queue = [];

        var qty = $("#quantity", form).val();
        var data = form.serialize();
        var dataArray = form.serializeArray();
        const valueIdForm = dataArray[2].value;

        Shopify.queue.push({
            giftProductVariant: valueIdForm,
            quantity: qty,
        });

        if ($('.messageChecked').length > 0) {
            const messageAddonProductId = '40896469073968';
            const messageToAttr = document.getElementById("message-addons-to").value;
            const messageFromAttr = document.getElementById("message-addons-from").value;
            const messageMsgAttr = document.getElementById("message-addons-message").value;
            Shopify.queue.push({
                giftProductVariant: messageAddonProductId,
                quantity: 1,
                properties:{
                    To: messageToAttr,
                    From: messageFromAttr,
                    Message: messageMsgAttr,
                    _paired_product_id: valueIdForm,
                }
            });
        }

        if ($('.ribbonChecked').length > 0) {
            const ribbonAddonProductId = '40896390922288';
            Shopify.queue.push({
                giftProductVariant: ribbonAddonProductId,
                quantity: qty,
                _paired_product_id: valueIdForm,
            });
        }

        Shopify.moveAlong = function() {
            // If we still have requests in the queue, let's process the next one.
            if (Shopify.queue.length) {
              var request = Shopify.queue.shift();
              var data = {
                quantity: request.quantity,
                id: request.giftProductVariant
              };
              var itemProperties = request.properties;
              if(itemProperties != false){
                data.properties = itemProperties;
              }
              $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                dataType: 'json',
                data: data,
                success: function(res){
                  console.log('success');
                  Shopify.moveAlong();
                quantity += 1;
               },
                   error: function(){
               // if it's not last one Move Along else update the cart number with the current quantity
                    if (Shopify.queue.length){
                    Shopify.moveAlong();
                    }
                }
                 });
            }else{ //queue is empty, open minicart
              miniCartInit("open");
            }
        };
          Shopify.moveAlong();
    };


       // Form validation function to prevent checkout some input not filled
    function formValidation() {
        var isValid = false;
        const messageToAttr = document.getElementById("message-addons-to").value;
        const messageFromAttr = document.getElementById("message-addons-from").value;
        const messageMsgAttr = document.getElementById("message-addons-message").value;
        if(messageToAttr.length == 0 || messageFromAttr.length == 0 || messageMsgAttr.length == 0){
            isValid = false;
        }else{
            isValid = true;
        }
        return isValid;
    }

    let checkCartCount = function checkCartCount( qty ){
      let cart = $(".side_cart .count:first");
      if ( cart.length > 0 ){
        let cart_value = cart.text();
        cart_value = parseInt(cart_value) + parseInt(qty);
        $('.count').html(cart_value);
      }
    }

    //add a sidecart loading icon to on top of the bin icon
    window.addEventListener("load", (event) => {
        $('.while-loading').removeClass('while-loading');
        $('.while-loading a').fadeIn();
      });

    window.miniCartInit = function miniCartInit(open) {
        if ($(".side_cart").length != 0) {
            var cart;
            var url = "/cart?view=sidecart";
            $.ajax({
                url: url,
                success: function (cartpage) {
                    if ($("#side_cart").length > 0) {
                        $("#side_cart").html("");
                        cartpage = $(cartpage).filter("#side_cart").html();
                        $("#side_cart").append(cartpage);
                        var count = $(".count.hide").text();
                        $(".count").html(count);
                    }
                    else {
                        $(cartpage).appendTo("body");
                    }
                    if (!cn(open)) {
                        miniCartOpen();
                    }
                }
            }).done(function () {
                $.fn.sideCartUpsellSecondProductHideShow();
                setTimeout(function () {
                    $(".trigger_popup_fricc").click(function () {
                        $(this).parents("#side_cart").next(".hover_bkgr_fricc").show();
                        var did = $(this).attr("data-variant");
                        $(this).parents("#side_cart").next(".hover_bkgr_fricc").find(".cart-delete-btn").attr('rel', did);
                        $.each($('#table--cart').find('.cart-item'), function (index, value) {
                            var hrefData = $(this).find('.hidden-delete-btn').attr('href');
                            var wishlistItem = $(this).find('.hidden-wishlist-btn').attr('data-product-id');
                            var dataVariantId = $(this).attr('data-variant');
                            $('.cart-delete-btn').attr('rel', dataVariantId);
                            $('.cart-delete-btn').attr('href', hrefData);
                            $('.add-wishlist-btn').attr('data-product-id', wishlistItem);
                            $('.add-wishlist-btn').attr('data-variant', dataVariantId);
                        });
                    });
                    $('.hover_bkgr_fricc').click(function () {
                        $('.hover_bkgr_fricc').hide();
                    });
                    $('.popupCloseButton').click(function () {
                        $('.hover_bkgr_fricc').hide();
                    });
                }, 2500);
                $.fn.sideCartUpsellHeightChange();

                $.each($('#side_cart').find('.items'), function (index, value) {
                    var hrefData = $(this).find('.hidden-delete-btn').attr('href');
                    var wishlistItem = $(this).find('.hidden-wishlist-btn').attr('data-product-id');
                    var dataVariantId = $(this).find('.product__members-popup-btn').attr('data-variant');
                    $('.cart-delete-btn').attr('rel', dataVariantId);
                    $('.cart-delete-btn').attr('href', hrefData);
                    $('.add-wishlist-btn').attr('data-product-id', wishlistItem);
                    $('.add-wishlist-btn').attr('data-variant', dataVariantId);
                });
            });
        }
    };


    //Giftcard variant id depending on cart total value - BCFM 2023
    // function getGcIdValueDependingOnTotal() {
    //     if (window.location.href.indexOf("cart") > -1) {
    //         var cartTotalprice = $(".section-cart-page .form--cart .carttotal__price .price").text().replace("$", "").replace(",", "");
    //     }else{
    //         var cartTotalprice = $(".table__finaltotal-value .cart__subtotal__price").text().replace("$", "").replace(",", "");
    //     }
    //     var cartTotal = parseInt(cartTotalprice);
    //     console.log(cartTotal);
    //     return cartTotal >= 100 && cartTotal < 250  ? 41033325805616
    //     : cartTotal >= 250 && cartTotal < 500  ? 40927011799088
    //     : cartTotal >= 500 && cartTotal < 750  ? 40927011831856
    //     : cartTotal >= 750 && cartTotal < 1000  ? 40927011864624
    //     : cartTotal >= 1000  ? 41033326231600
    //     : 0;
    // }

    // //btn checkout cart page on click
    // if (window.location.href.indexOf("cart") > -1) {
    //     $('.section-cart-page .form--cart .form__actions .btn--checkout').on('click', function (e) {
    //         e.preventDefault();
    //         const cartAddedGcId = getGcIdValueDependingOnTotal();
    //         console.log(cartAddedGcId);
    //         cartAddedGcId == 0 ? window.location.href = "/checkout" : window.location.href = "/cart/add?items[][id]="+cartAddedGcId+"&items[][quantity]=1&return_to=/checkout";
    //     });
    // }

    //sideCart checkout function
    var miniCartUpdate = function miniCartUpdate(form, checkout) {
        var params = {
            type: 'POST',
            url: '/cart',
            data: form.serialize(),
            dataType: 'json',
            success: function (line_item) {
                if (!cn(checkout)) {
                    window.location.href = "/checkout";
                    // const cartAddedGcId = getGcIdValueDependingOnTotal();
                    // console.log(cartAddedGcId);
                    // cartAddedGcId == 0 ? window.location.href = "/checkout" : window.location.href = "/cart/add?items[][id]="+cartAddedGcId+"&items[][quantity]=1&return_to=/checkout";
                }
                else {
                    var cart_count = line_item.item_count;
                    $(".count").html(cart_count);
                    $("#side_cart .update:first").text("Update");
                }
                miniCartInit();
            },
            error: function (XMLHttpRequest, textStatus) {
                var error = JSON.parse((XMLHttpRequest.responseText)).description;
                error = "<h6>" + error + "</h6>";
                $("#fancy_msg").html("").append(error);
                $("#side_cart .update:first").text("Update");
            }
        };
        $("#side_cart .no_data").fadeOut();
        jQuery.ajax(params);
    };

    miniCartInit();

    //header-top
    if ($(window).width() > 767) {
        $(window).scroll(function () {
            var headerHeight = $('.header').outerHeight();
            var scroll = $(window).scrollTop();
            if (scroll > headerHeight) {
                $('#side_cart').css('top', '0px');
            } else {
                $('#side_cart').css('top', headerHeight + 'px');
            }
        });
    }


    //account-recharge-subscription-page
    $('.subscription-block  .cancel-btn').on('click', function (e) {
        e.preventDefault();
        $(this).parent().parent().next(".subscription-block.third-block").show();
        $(this).parent().parent().hide();
        $(this).parent().parent().siblings(".second-block").hide();
    });
    $('.subscription-block  .cancel-decline').on('click', function (e) {
        e.preventDefault();
        $(this).parent().parent().hide();
        $(".subscription-block.second-block").show();
        $(".subscription-block.first-block").show();
    });

    // Page-faq
    $('.section-faq .question-wrapper').on('click', function (e) {
        $(this).parent().toggleClass('is-active');
        $(this).parent().find('.answer-wrapper').slideToggle();
    });

    $('.section-faq .section__tab li').on('click', function (e) {
        $('.section-faq .section__tab li a').removeClass('is-active');
        $(this).children('a').addClass('is-active');
        var current_page = $(this).children('a').attr('data-page');
        $('.faq-wrapper').hide();
        $('.heading').hide();
        $('.faq-wrapper.' + current_page).show();
        $('.heading.' + current_page).show();
        if (current_page == 'all') {
            $('.heading').show();
            $('.section-faq .section__body .faq-wrapper:gt(8)').hide();
            $('.section-faq .see_more_btn').show();
        }
        else {
            $('.section-faq .see_more_btn').hide();
        }
    });
    //   console.log(window.location.href,'(window.location.href');

    // order-history-page

    if (window.location.href.indexOf("gifts") > -1) {
        //console.log('test-faq-page......');
        $('.section-faq .section__body .faq-wrapper:gt(3)').hide();
        $('.section-faq .see_more_btn').show();
    }
    else {
        $('.section-faq .see_more_btn').hide();
    }

    $('.section-faq .see_more_btn').click(function () {
        $('.section-faq .section__body .faq-wrapper:gt(8)').toggle('slide');
        $('.section-faq .see_more_btn').toggleClass('active');
        if ($('.section-faq .see_more_btn').hasClass('active')) {
            $('.section-faq .see_more_btn').text("See Less");
        }
        else {
            $('.section-faq .see_more_btn').text("See more");
        }
    });

    // Page-Subs
    $('.section-account-whisky-chapters .question-wrapper').on('click', function (e) {
        if (!$(this).parent().hasClass('is-locked')) {
            $(this).parent().toggleClass('is-active');
            $(this).parent().find('.answer-wrapper').slideToggle();
        }
    });

    if ($('.section-home-subscription')) {
        $('.subscribe-btn').click(function () {
            var current_box_variant_id = $(this).attr('data-variant-id');
            var current_selling_plan_id = $(this).attr('data-selling-plan-id');
            var current_product_name = $(this).attr('data-product-name');
            bentoAddItemToCart(current_box_variant_id, 1, current_selling_plan_id)
        });
    }

    function bentoAddItemToCart(variant_id, qty, selling_plan_id, giftLineItemProperties) {
        const data = {
            "id": variant_id,
            "quantity": qty,
            "properties": {}
        }

        if (selling_plan_id) {
            data.selling_plan = selling_plan_id
        }

        if (giftLineItemProperties !== undefined && Object.keys(giftLineItemProperties).length > 0) {
            data.properties = Object.assign(data.properties, giftLineItemProperties);
        }

        jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function () {
                console.log('success');
                window.location.href = '/cart';
            }
        });
    }


    function addItemToCartMonthly(variant_id, qty, selling_plan_id) {
        Shopify.queue = [];

        // const discount_code = 'WLFREESHOT';

        //wl_free_shot_var_id = 40668191817776
        /* Shopify.queue.push({
            giftProductVariant: 40668191817776,
        }); */

        Shopify.queue.push({
            giftProductVariant: variant_id,
        });

        Shopify.moveAlong = function() {
            // If we still have requests in the queue, let's process the next one.

            if (Shopify.queue.length) {
              var request = Shopify.queue.shift();
              var data = {
                id: request.giftProductVariant,
                quantity: 1,
              };

            if (selling_plan_id && Shopify.queue.length == 0 ) { //last item in queue is Monthly sub
                data.selling_plan = selling_plan_id
            }

            $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: data,
            success: function(res){
                setTimeout(function () {
                  Shopify.moveAlong();
                }, 1000);
            },
            error: function(){
                if (Shopify.queue.length){
                    Shopify.moveAlong();
                }
            }
                });
            }else { //queue is empty, redirect
            console.log('Redirecting to checkout');
            /* window.location.href = '/discount/' + discount_code + '?redirect=/checkout'; */
              window.location.href = '/checkout';
            }
        };
          Shopify.moveAlong();
    };

    function addItemToCartGiftCardUpsell(variant_id, qty, giftLineItemProperties) {
        Shopify.queue = [];

        var wl_free_gc_var_id = '';
        if (variant_id == 39992897732656 || variant_id == 39997424926768) {
            var wl_free_gc_var_id = 40922264797232
        }
        else if(variant_id == 39992897830960 || variant_id == 39997424861232) {
            var wl_free_gc_var_id = 40922264830000
        }

        Shopify.queue.push({
            giftProductVariant: wl_free_gc_var_id,
        });

        Shopify.queue.push({
            giftProductVariant: variant_id,
        });


        Shopify.moveAlong = function() {
            // If we still have requests in the queue, let's process the next one.

            if (Shopify.queue.length) {
              var request = Shopify.queue.shift();
              var data = {
                id: request.giftProductVariant,
                quantity: 1,
                properties: {},
              };


            if (giftLineItemProperties !== undefined && Object.keys(giftLineItemProperties).length > 0 && Shopify.queue.length == 0) {
                //last item in queue is Monthly sub
                data.properties = Object.assign(data.properties, giftLineItemProperties);
            }

            console.log(Shopify.queue.length);
            console.log(request.giftProductVariant);

            $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: data,
            success: function(res){
                console.log('success');
                Shopify.moveAlong();
            },
            error: function(){
                if (Shopify.queue.length){
                    Shopify.moveAlong();
                }
            }
                });
            }else { //queue is empty, redirect
            console.log('Redirecting to cart');
            window.location.href = '/cart';
            }
        };
          Shopify.moveAlong();
    };

    function AddItemToCart(variant_id, qty, giftLineItemProperties) {
        const data = {
            "id": variant_id,
            "quantity": qty,
            "properties": {
            },
        }
        if (giftLineItemProperties !== undefined && Object.keys(giftLineItemProperties).length > 0) {
            data.properties = Object.assign(data.properties, giftLineItemProperties);
        }
        jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function () {
                console.log('success');
                window.location.href = '/cart';
            }
        });
    }

    /* multiple address auto function */
    if (window.location.href.indexOf("/products/") > -1) {
        $('#doubleBoxButton').on('click', function () {
            var current_box_product_id = $('#doubleBoxButton').attr('data-product-id');
            window.location.href = '/pages/box-for-two#box-' + current_box_product_id;
        });
    }

    /*
    /// GIFT ONBOARDING ///
    */

    if (window.location.href.indexOf("gifts-onboarding") > -1) {
    $('.checkout__gift_btn').click(function (e) {
        // Validate required fields and checkbox
        if ($(".gift_message_form .required").val().length == 0 || !$("#requird-checkbox").is(':checked')) {
            $('.gift_message_form .form__message--error').text("Please verify all details are entered correctly");
            e.preventDefault();
            return;
        }

        // Validate email addresses using a basic regex
        var recipientEmail = $("#gift_recipient_email").val().trim();
        var customerEmail  = $("#gift_customer_email").val().trim();
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        
        if (!emailRegex.test(recipientEmail) || !emailRegex.test(customerEmail)) {
            $('.gift_message_form .form__message--error').text("Please enter valid email addresses for both recipient and customer.");
            e.preventDefault();
            return;
        }

        // If validations pass, build gift line item properties and add item to cart
        var giftLineItemProperties = {
            RecipientName: $("#gift_recipient_name").val(),
            RecipientEmail: $("#gift_recipient_email").val(),
            CustomerName: $("#gift_customer_name").val(),
            CustomerEmail: $("#gift_customer_email").val(),
            Message: $("#gift_recipient_message").val(),
            SendToBoth: $("#gift-send-both").is(':checked'),
        };
        var current_box_variant_id = $(this).attr('data-variant-id');
        console.log('current_box_variant_id', current_box_variant_id);
        AddItemToCart(current_box_variant_id, 1, giftLineItemProperties);
    });
}


    //home-page-subscription
    $(".section-home-subscription .product_wrapper ul.select-box").on("click", ".init", function () {
        if ($(this).closest(".section-home-subscription .product_wrapper ul.select-box").children('li:not(.init)').hasClass("active")) {
            $(".section-home-subscription .product_wrapper ul.select-box").removeClass('toggle');
            $(this).closest(".section-home-subscription .product_wrapper ul.select-box").children('li:not(.init)').removeClass('active');
        }
        else {
            $(".section-home-subscription .product_wrapper ul.select-box").addClass('toggle');
            $(this).closest(".section-home-subscription .product_wrapper ul.select-box").children('li:not(.init)').addClass('active');
        }
    });

    var allOptions = $(".section-home-subscription .product_wrapper ul.select-box").children('li:not(.init)');
    $(".section-home-subscription .product_wrapper ul.select-box").on("click", "li:not(.init)", function () {
        var current_product = $(this).text();
        $(".section-home-subscription .product_wrapper").removeClass('is-active');
        $(".section-home-subscription ." + current_product + ".product_wrapper").addClass('is-active');
        allOptions.removeClass('selected');
        $(this).addClass('selected');
        $(".section-home-subscription .product_wrapper.is-active ul.select-box").children('.init').html($(this).html());
        allOptions.removeClass('active');
    });

    //collection-header-member-popup
    if ($(window).width() < 768) {
        if ($(".template-collection").length > 0) {
            $('.template-collection .member-popup').insertAfter('.template-collection .mobile-filter-wrapper');
        }
    }

    //subscription-page and gift-page
    $(".hero--subscription .hero__actions a,.hero--gifts .hero__actions a.first, .template-page--home-alternative .hero__actions a.first, .template-page--home-alternative .section__actions a").click(function () {
        $('html, body').animate({
            scrollTop: $('.slider-cards').offset().top - 60
        }, 1500);
    });

    /* deprecated as we now apply the discount always on tiles - discount added to subscription page
      //$10 discount code recharge
    $(".header .discount_bar").click(function() {
        if (Cookies.get('subscription_discount') == null){
            Cookies.set('subscription_discount', 'true', { path: '' });
        }
    });

    if (Cookies.get('subscription_discount')) {
        $('.section-product-subscription .btn-full').show();
        var disc = $(".section-product-subscription .subscription-card__price").attr("data-discount");
        var monthly_price = parseInt($(".section-product-subscription .monthly .subscription-card__price ins.price__amount .money").text().replace('$', '') - disc);
        //var yearly_price = parseInt($(".section-product-subscription .yearly .subscription-card__price ins.price__amount .money").text().replace('$', '') - disc);
        $(".section-product-subscription .monthly .subscription-card__price ins.price__amount .money" ).text("$" + monthly_price);
        //$(".section-product-subscription .yearly .subscription-card__price ins.price__amount .money" ).text("$" + yearly_price);
    }
    */

    $('.gift-product').change(function () {
        if (this.checked) {
            $('.gift-product').prop("checked", this.checked);
            //$(".product_wrapper").hide();
            //$(".product_wrapper.product-index-"+productIndex).show();
            $(".section__content.product-advent-wrapper").removeClass("product-advent-wrapper-active");
            $(".section__content.product-advent-wrapper-gift").addClass("product-advent-wrapper-active");
        }
        else {
            $('.gift-product').prop("checked", this.checked);
            $(".section__content.product-advent-wrapper").addClass("product-advent-wrapper-active");
            $(".section__content.product-advent-wrapper-gift").removeClass("product-advent-wrapper-active");
        }
    })

    $('#advent__video').click(function () {
        console.log(this.paused);
        if (this.paused == false) {
            this.pause();
            $(".advent_video_btn").removeClass('hide-video-btn');
        } else {
            this.play();
            $(".advent_video_btn").addClass('hide-video-btn');
        }
    });

    $('.advent_video_btn').click(function () {
        $('#advent__video').get(0).play();
        $(".advent_video_btn").addClass('hide-video-btn');
    });

    //global-site-menu
    $('.header__bar .bar__link').on("click", function () {
        $(".global__websitemenu").toggleClass('is-active');
        if ($(".global__websitemenu").hasClass('is-active')) {
            $('body').addClass('overflow_hidden');
        } else {
            $('body').removeClass('overflow_hidden');
        }
    });
    $(".global__websitemenu .close-btn").click(function () {
        $(".global__websitemenu").removeClass("is-active");
        $('body').removeClass('overflow_hidden');
    });
    $('.global-mobile-link').click(function () {
        $(this).toggleClass('is-active');
        $('.global__websitemenu_mobile').toggleClass('is-active');
    });

    //nav site dropdown active siblings are removed when click
    $('.js-nav-hover > ul > li > a, .js-has-dropdown > ul.menu__dropdown > li > a').click(function () {
        $(this).parent().siblings().removeClass('is-active');
        $(this).parent().siblings().children().removeClass('is-active');
        setTimeout(function () {
            if (!$('.js-has-dropdown.is-active').length) {
                $('.mega-menu-overlay').removeClass('is-active');
            }
        }, 100);
    });

    //Click outside the megamenu should close it
    $('.mega-menu-overlay').on("click", function () {
        $(this).removeClass('is-active');
        $('.menu__dropdown').removeClass('is-active');
        $('.menu__item').removeClass('is-inactive');
    });

    // Change button text when user change membership option - quick buy popup
    $(".radio-checkbox").first().prop("checked", true);
    // $(document).on('click', '.monthly-whisky-advanced .explorer-popup-btn', function(){
    //     setTimeout(function() {
    //         $("input.radio-checkbox:first-child").attr('checked', false);
    //     $("#explorer-quick-buy-2").find('input.radio-checkbox:first-child').attr('checked', true);
    //     }, 500);

    // });
    $(document).on('change', '.subscription-option .radio-checkbox', function () {
        if ($(this).next('label').attr('for') == 'option-1') {
            var title = $(this).next('label').attr('aria-label');
        } else {
            var title = $(this).next('label').text();
        }
        $('.mfp-content .membership-buy-btn .btn-text').text(title);
    });

    // Change button text when user change membership option - Membership page
    $(document).ready(function () {
        $("input.radio-checkbox:checked").parent().closest('.membership-first-option.options-withtonic').addClass('checked');

        $('input.radio-checkbox').change(function () {
            var $this = $(this);
            if ($(this).next('label').attr('for') == 'option-1') {
                $("input.radio-checkbox:checked").parent().closest('.membership-first-option.options-withtonic').addClass('checked');
                $('input.radio-checkbox').parent('.membership-option').removeClass("checked");
                $("input.radio-checkbox:checked").parent().closest('.membership-first-option.options-notonic').removeClass('checked');
            }
            else if ($(this).next('label').attr('for') == 'option-5') {
                $("input.radio-checkbox:checked").parent().closest('.membership-first-option.options-notonic').addClass('checked');
                $("input.radio-checkbox:checked").parent().closest('.membership-first-option.options-withtonic').removeClass('checked');
                $('input.radio-checkbox').parent('.membership-option').removeClass("checked");
            } else {
                if ($this.is(":checked")) {
                    $("input.radio-checkbox").parent().closest('.membership-first-option.options-withtonic').removeClass('checked');
                    $("input.radio-checkbox").parent().closest('.membership-first-option.options-notonic').removeClass('checked');
                    $('input.radio-checkbox').parent('.membership-option').removeClass("checked");
                    $(this).parent('.membership-option').addClass("checked");
                }
            }
        });
    });
    // $(document).on('change', '.membership-option .radio-checkbox', function(){
    //     if($(this).next('label').attr('for') == 'option-1'){
    //         var title = $(this).next('label').attr('aria-label');
    //     }else{
    //         var title = $(this).next('label').text();
    //     }

    // add to cart subscription option for subscription quick buy popup
    $(document).on('click', '.mfp-content .membership-buy-btn', function () {
        var selected_option = $('.mfp-content .subscription-option .radio-checkbox:checked');
        var current_box_variant_id = parseInt( selected_option.val(), 10 );
        var current_product_name = selected_option.attr('data-product');
        var current_selling_plan_id = parseInt( selected_option.attr('data-selling-plan-id'), 10);
        console.log('current_product_name', current_product_name);
        if (current_product_name.indexOf("one-off") > -1) {
            AddItemToCart(current_box_variant_id, 1)
        } else if (current_product_name.indexOf("monthly") > -1) {
            addItemToCartMonthly(current_box_variant_id, 1, current_selling_plan_id)
        } else {
            bentoAddItemToCart(current_box_variant_id, 1, current_selling_plan_id)
        }
    });

    // add to cart subscription membership option for membership pages
    $(document).on('click', '.membership-btn-wrapper .membership-buy-btn', function () {
      /* $.getJSON('/cart.js', function(cart) {
        let variantIdsToCheck = [39983954165808, 39983954395184]; // Add more variant IDs as needed
        let productInCart = cart.items.some(item => variantIdsToCheck.includes(item.id));
    
        if (productInCart) {
            
            let popup_html = `<div class="cart-popup-error">
                                <div class="popup-content-wrapper">
                                  <div class="popup-content">
                                    <p>Please checkout individually for multiple subscription, gift card or redemption orders.</p>
                                    <p>Must have at most 1 of subscription - 1 max per checkout.</p>
                                  </div>
                                  <div class="popup-cta">
                                    <span class="close-popup">OK</span>
                                  </div>
                                </div>
                              </div>`;
          $('#MainContent').append(popup_html);
          $('html').addClass('no-scroll');
        } else {
          $(this).parents('.membership-btn-wrapper').find('img').css('display', 'block');
          $(this).css('pointer-events', 'none');
          $(this).css('opacity', '0.8');
          
          var selected_option = $('.membership-option .radio-checkbox:checked');
          var current_box_variant_id = parseInt( selected_option.val(), 10 );
          var current_product_name = selected_option.attr('data-product');
          var current_selling_plan_id = parseInt( selected_option.attr('data-selling-plan-id'), 10);
          if (current_product_name.indexOf("one-off") > -1) {
            AddItemToCart(current_box_variant_id, 1)
          } else if (current_product_name.indexOf("monthly") > -1) {
            addItemToCartMonthly(current_box_variant_id, 1, current_selling_plan_id)
          } else {
            bentoAddItemToCart(current_box_variant_id, 1, current_selling_plan_id)
          }
        }
      }); */

        /* $(this).parents('.membership-btn-wrapper').find('img').css('display', 'block');
        debugger;
        var selected_option = $('.membership-option .radio-checkbox:checked');
        var current_box_variant_id = parseInt( selected_option.val(), 10 );
        var current_product_name = selected_option.attr('data-product');
        var current_selling_plan_id = parseInt( selected_option.attr('data-selling-plan-id'), 10);
        if (current_product_name.indexOf("one-off") > -1) {
        AddItemToCart(current_box_variant_id, 1)
        } else if (current_product_name.indexOf("monthly") > -1) {
        addItemToCartMonthly(current_box_variant_id, 1, current_selling_plan_id)
        } else {
        bentoAddItemToCart(current_box_variant_id, 1, current_selling_plan_id)
        } */
    });

    /* Added for new Subscription */
    $(document).on('click', '.membership-btn-wrapper .membership-buy-btn .subscribe_now_btn', function () {
      $.getJSON('/cart.js', function(cart) {
        let variantIdsToCheck = [39983954165808, 39983954395184]; // Add more variant IDs as needed
        let productInCart = cart.items.some(item => variantIdsToCheck.includes(item.id));

        let selectedPlanId = document.querySelector('input[name="selling_plan_radio"]:checked').value;
        if( selectedPlanId ){
            let itemAttributeInfo = '';
            /* Monthly WA */
            if( selectedPlanId == 2459205680 ){
                itemAttributeInfo = ' Billed every 1 order. $40.00 discount';
            }
            /* 3 Months WA */
            if( selectedPlanId == 2459140144 ){
                itemAttributeInfo = ' this charge will end after the last shipment';
            }
            /* 6 Months WA */
            if( selectedPlanId == 2459828272 ){
                itemAttributeInfo = ' this charge will end after the last shipment';
            }
            /* 12 Months WA */
            if( selectedPlanId == 2459795504 ){
                itemAttributeInfo = ' this charge will end after the last shipment';
            }
            /* Monthly WE */
            if( selectedPlanId == 2466414640 ){
                itemAttributeInfo = ' Billed every 1 order. $20.00 discount';
            }
            /* 3 Months WE */
            if( selectedPlanId == 2466447408 ){
                itemAttributeInfo = ' this charge will end after the last shipment';
            }
            /* 6 Months WE */
            if( selectedPlanId == 2466480176 ){
                itemAttributeInfo = ' this charge will end after the last shipment';
            }
            /* 12 Months WE */
            if( selectedPlanId == 2466512944 ){
                itemAttributeInfo = ' this charge will end after the last shipment';
            }

            if( itemAttributeInfo != '' ){
                document.querySelector('.subscription_delivery_property').value = itemAttributeInfo;
            }
        }
    
        /*if (productInCart) {
            let popup_html = `<div class="cart-popup-error">
                                <div class="popup-content-wrapper">
                                  <div class="popup-content">
                                    <p>Please checkout individually for multiple subscription, gift card or redemption orders.</p>
                                    <p>Must have at most 1 of subscription - 1 max per checkout.</p>
                                  </div>
                                  <div class="popup-cta">
                                    <span class="close-popup">OK</span>
                                  </div>
                                </div>
                              </div>`;
          $('#MainContent').append(popup_html);
          $('html').addClass('no-scroll');
        } else {
          $('.membership-btn-wrapper button.add-cart-button').click();
        } */
        $('.membership-btn-wrapper button.add-cart-button').click();
      });
    });

    

    $('body').on('click', '.cart-popup-error .popup-cta .close-popup', function(){
      $('html').removeClass('no-scroll');
      $('.cart-popup-error').remove();
    });

    // add to cart subscription for Explorer and advanced membership
    $(document).on('click', '.membership-card__btn', function (e) {
        e.preventDefault();
        var selected_option = $(this).closest('.swiper-slide'); 
        var current_box_variant_id = parseInt( selected_option.attr('data-variant-id'), 10);
        var current_product_name = selected_option.attr('data-product-name');
        var current_selling_plan_id = parseInt( selected_option.attr('data-selling-plan-id'), 10);
        bentoAddItemToCart(current_box_variant_id, 1, current_selling_plan_id);
    });

    // add to cart for Gifts membership
    // whisky gin gift subscription code
    $(document).ready(function () {
        var querySelector = window.location.search;

        if (querySelector == '?q=Choose-a-whisky-gift') {
            $("#gin-gift-product").trigger("click");
        }

    });
    $(document).on('click', '.gifts-card__btn', function (e) {
        e.preventDefault();
        var selected_option = $(this).closest('.swiper-slide');
        var current_box_product_name = selected_option.attr('data-product-name');
        window.location.href.replace(window.location.search, '');
        //console.log('current_box_product_name', current_box_product_name, window.location.href);
        // if (current_box_product_name.indexOf('-giftcard-whisky-advanced') >= 0) {
        //     current_box_product_name = current_box_product_name.replace('-giftcard-whisky','');
        //     console.log('test area 1 ',current_box_product_name);
        // } else {
        //     current_box_product_name = current_box_product_name.replace('-giftcard-whisky-explorer','-explorer');
        //     console.log('test area 2 ',current_box_product_name);
        // }
        if (current_box_product_name.indexOf('-giftcard-gin') >= 0) {
            var thequerystring = 'Choose-a-whisky-gift';
            window.location.href = '/pages/gifts-onboarding?q=' + thequerystring + '#' + current_box_product_name;
            //console.log(selected_option, current_box_product_name);
        } else {
            window.location.href = '/pages/gifts-onboarding#' + current_box_product_name;
        }
    });

    //virtual page js start
    $(document).on('change', '.tasting-checkbox input[type="checkbox"]', function (e) {
        e.preventDefault();
        var selected_option = $(this).closest('.swiper-slide');
        var current_box_product_name = selected_option.attr('data-product-name');
        $('.tasting-checkbox input[type="checkbox"]').removeClass('active-box');
        if (current_box_product_name.indexOf('-giftcard-advanced') >= 0) {
            current_box_product_name = current_box_product_name.replace('-giftcard', '');
        } else {
            current_box_product_name = current_box_product_name.replace('-giftcard', '-explorer');
        }
        window.location.href = '/pages/virtual-tasting-onboarding#' + current_box_product_name;
    });
    if (window.location.href.indexOf("virtual-tasting-onboarding") > -1) {

        jQuery(function () {
            jQuery(".self-tasting-wrapper").click(function () {
                $('input[type=radio]', this).prop("checked", true);
                $(this).find('.subscription-card__actions .virtual-gift-card__btn').trigger('click');
            });
        });

        $('.virtual-gift-card__btn').on('click', function () {
            $(this).parents('.js-cards-item').addClass('selected-card').siblings().removeClass('selected-card');
            var active_box = $('.selected-card .subscription_product_title').text();
            var active_box_price = $('.selected-card .self-tasting-price').find('ins.price__amount span').text();
            var active_category = $('.select-membership-category .btn-group .active span').text();
            $('.selected-box span').text(active_box + ' ' + active_box_price);
        });

        var active_box = $('.selected-card .subscription_product_title').text();
        if (active_box.indexOf("off") > -1) {
            $('.selected-box span').text(active_box);
        } else {
            $('.selected-box span').text(active_box);
        }
    }
    //virtual page js end


    // Toggle switch for membership options
    $(document).on('click', '.btn-group button', function (e) {
        e.preventDefault();
        $(this).closest('.btn-group').find('button').removeClass('active');
        $(this).addClass('active');
        var category = $(this).val();
        if (category == "Explorer") {
            $('.advanced-content').hide();
            $('.explorer-content').show();
            $(".select-membership-product .selected-card").removeClass("selected-card");
            // $('.select-explorer-membership-product').find('.js-cards-item').first().addClass('selected-card');
            // $('.select-explorer-membership-product').find('input[type=radio]').first().prop("checked",true);
            $('.select-explorer-membership-product').find('.subscription-card__actions .gift-card__btn').first().trigger('click');
            $('.select-advanced-membership-product').fadeOut('slow', function () {
                $('.select-explorer-membership-product').fadeIn('slow', function () {
                    window.dispatchEvent(new Event('resize'));
                });
            });
        }
        else if (category == "Advanced") {
            $('.explorer-content').hide();
            $('.advanced-content').show();
            $(".select-membership-product .selected-card").removeClass("selected-card");
            // $('.select-advanced-membership-product').find('.js-cards-item').first().addClass('selected-card');
            // $('.select-advanced-membership-product').find('input[type=radio]').first().prop("checked",true);
            $('.select-advanced-membership-product').find('.subscription-card__actions .gift-card__btn').first().trigger('click');
            $('.select-explorer-membership-product').fadeOut('slow', function () {
                $('.select-advanced-membership-product').fadeIn('slow', function () {
                    window.dispatchEvent(new Event('resize'));
                });
            });
        }
    });

    function updateContainer() {
        var $containerWidth = $(window).width();
        if ($containerWidth < 768) {
            $('ul.tabs').find('a').each(function () {
                var link_txt = $(this).text().replace('Explorer', '');
                //console.log('link_txt', link_txt);
                $(this).text(link_txt);
            });
        }
    }
    $(document).ready(function () {
        // var data_category = $('#category-data').attr('data-category');
        $('ul.tabs').each(function () {
            updateContainer();
            $(window).resize(function () {
                updateContainer();
            });

            var active, content, links = $(this).find('a');
            if ($('.index-membership-product').length) {
                active = links.first().addClass('active');
                links.not(':first').each(function () {
                    $($(this).attr('href')).hide();
                });
            }else{
                active = links.last().addClass('active');
                links.not(':last').each(function () {
                    $($(this).attr('href')).hide();
                });
            }

            content = $(active.attr('href'));
            $(active).parent('li').addClass('parent-active');

            $(this).find('a').click(function (e) {
                active.removeClass('active');
                active.parent('li').removeClass('parent-active');
                content.hide();
                active = $(this);
                content = $($(this).attr('href'));
                active.addClass('active');
                active.parent('li').addClass('parent-active');
                content.show();
                return false;
            });
        });
    });


    // Homepage advanced product tab
    $(document).on('click', '.btn-group button', function (e) {
        e.preventDefault();
        $(this).closest('.btn-group').find('button').removeClass('active');
        $(this).addClass('active');
        var category = $(this).val();
        if (category == "Whisky") {
            $('.advanced-content').hide();
            $('.explorer-content').show();
            $('.select-advanced-membership-product').fadeOut('slow', function () {
                $('.select-explorer-membership-product').fadeIn('slow', function () {
                    window.dispatchEvent(new Event('resize'));
                });
            });
        }
        else if (category == "Gin") {
            $('.explorer-content').hide();
            $('.advanced-content').show();
            $('.select-explorer-membership-product').fadeOut('slow', function () {
                $('.select-advanced-membership-product').fadeIn('slow', function () {
                    window.dispatchEvent(new Event('resize'));
                });
            });
        }
    });

    // Homepage collection tabs
    if ($('.shop-tabs').length > 0) {
        $(document).on('click', '.shop-tabs a', function (e) {
            e.preventDefault();
            var section_shop_id = "#" + $(this).closest(".section-shop").attr('id');
            //console.log(section_shop_id);
            $(section_shop_id + ' .shop-tabs a').removeClass('active');
            $(this).addClass('active');
            var handle = $(this).attr('data-handle');
            $(section_shop_id + ' .tab-content').hide().removeClass('active');
            $(section_shop_id + ' #tab-' + handle).show().addClass('active');
            $(section_shop_id + ' .tab-content.active .smart-collection-item__image').each(function () {
                var stl = $(this).attr('data-style');
                $(this).attr('style', stl);
            });
        });

        $('.tab-content.active .smart-collection-item__image').each(function () {
            var stl = $(this).attr('data-style');
            $(this).attr('style', stl);
        });

        if (window.location.hash.indexOf("flash-sale") > -1) {
            $(function () {
                $("html, body").animate({
                    scrollTop: $(".section-shop-wrapper").offset().top
                }, 2000);
            });
        }
    }

    //featured videos
    if ($('.featured-videos').length) {
        $(document).on('click', '.featured-video-links', function () {
            var videoID = $(this).attr('data-video-id');
            $('.featured-videos .video-component').removeClass('current-video');
            $('.featured-videos .video-component[data-video-id="' + videoID + '"]').addClass('current-video');
        });
    }

    // FAQ expand all
    if ($('.expand_collapse_btn').length) {
        $(document).on('click', '.expand_collapse_btn', function () {
            if ($(this).hasClass('collapsed')) {
                $(this).text('Expand all').removeClass('collapsed');
                $('.faq-wrapper').removeClass('is-active');
                $('.answer-wrapper').hide();
            }
            else {
                $(this).text('Collapse all').addClass('collapsed');
                $('.faq-wrapper').addClass('is-active');
                $('.answer-wrapper').show();
            }
        });
    }

    //Flash sale - homepage
    if ($('.stock-deadline-wrapper').length) {
        $('.claimed').each(function () {
            var stock = $(this).attr('data-stock');
            var available = $(this).attr('data-available');
            var claimed = 100;
            if (available != '' && stock != '') {
                claimed = (parseInt(stock) - parseInt(available)) / stock * 100;
                if (claimed > 100) claimed = 100;
                if (claimed < 0) claimed = 0;
            }
            claimed = Math.ceil(claimed);
            $(this).find('.claim-text').text(claimed + '% CLAIMED');
            $(this).find('.claim-progress-bar').css('width', claimed + '%');
        });

        $('.remaining-time').each(function () {
            var $this = $(this);
            var deadline = $this.attr('data-deadline');
            var timeline = $this.attr('data-timeline');

            if (deadline && timeline) {
                var d = deadline.split('/');
                var t = timeline.split(':');

                // Set the date we're counting down to
                var countDownDate = new Date(d[2], d[1] - 1, d[0], t[0], t[1]).getTime();

                // Update the count down every 1 second
                var x = setInterval(function () {

                    // Get today's date and time
                    var now = new Date().getTime();

                    // Find the distance between now and the count down date
                    var distance = countDownDate - now;

                    // Time calculations for days, hours, minutes and seconds
                    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
                    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

                    // Output the result in an element with id="demo"
                    $this.html(('0' + days).slice(-2) + ":" + ('0' + hours).slice(-2) + ":" + ('0' + minutes).slice(-2) + ":" + ('0' + seconds).slice(-2));

                    // If the count down is over, write some text
                    if (distance < 0) {
                        clearInterval(x);
                        $this.html("EXPIRED");
                    }
                }, 1000);
            }
            else {
                $this.closest('.deadline').hide();
            }
        });
    }

    //Desktop mega menu (old liquorloot)
    $(document).on('mouseover', '.menu__dropdown.shop .shop-sidebar-menu li.menu__item', function () {
        if ($(this).hasClass('active')) return false;
        $('.menu__dropdown.shop .shop-sidebar-menu li').removeClass('active');
        $(this).addClass('active');

        var handle = $(this).attr('data-menu-handle');
        $('.side-menu').removeClass('active');
        $('.side-menu.' + handle).addClass('active');
    });

    //Desktop Spirit menu on hover open
    var menuLink = '';
    $(document).on('mouseenter', '.menu__dropdown--level-2 > .menu__item', function () {
        if ($(this).hasClass('menu__item--has-dropdown')) {
            menuLink = $(this).children('a');
            if ($(this).hasClass('is-active')) return false;
            menuLink[0].click();
        } else {
            if (menuLink[0].parent().hasClass('is-active')) return menuLink[0].click();
        }
    });


    //Sticky fixed menu on scroll
    $(window).scroll(function () {
        var sticky = $('.header__container'),
            scroll = $(window).scrollTop(),
            stickyFrom = 0;
        document.documentElement.clientWidth < 768 ? stickyFrom = 31 : stickyFrom = 42;
        scroll >= stickyFrom ? sticky.addClass('fixed') : sticky.removeClass('fixed');
    });

    //mobile-hamburger
    $(document).on('click', '#nav-icon3', function () {
        $(this).toggleClass('open');
        $('.menu__foot-link').toggleClass('is-active');
        if (!$(this).hasClass('open')) {
            $('.menu-mobile').removeClass('is-active');
            $('.menu__foot-link').removeClass('is-active');
            $('body').removeClass('is-fixed');
        }
    });
    //mobile-tab-based-menu
    $(document).on('click', '.mobile-nav ul.nav-tabs li', function () {
        var tab_id = $(this).attr('data-tab');
        $(this).parent().addClass('is-active');
        $('.mobile-nav ul.nav-tabs li, .mobile-nav .tab-content').removeClass('current');
        $(this).addClass('current');
        $("#" + tab_id).addClass('current');
        $(".mobile-nav .mobile-menu-aftership").toggleClass('menu-translate');
    });
    //mobile-tab-back-link
    $(document).on('click', '.mobile-nav .tab-content .mobile-menu-back-button', function () {
        var tab_id = $(this).parent().attr('id');
        $(".mobile-nav ul.nav-tabs").removeClass('is-active');
        $(".mobile-nav ul.nav-tabs .tab-link").removeClass('current');
        $("#" + tab_id).removeClass('current');
        $(".mobile-nav .mobile-menu-aftership").toggleClass('menu-translate');
    });
    //Mobile mega menu
    $(document).on('click', '.mobile-menu-group-heading', function (e) {
        e.preventDefault();
        if ($(this).hasClass('active')) {
            $('.mobile-mega-menu-wrapper .mobile-mega-menu, .mobile-menu-group-heading').removeClass('active');
        }
        else {
            $('.mobile-mega-menu-wrapper .mobile-mega-menu, .mobile-menu-group-heading').removeClass('active');
            $(this).closest('.mobile-menu-group-heading').next('.mobile-mega-menu').addClass('active');
            $(this).addClass('active');
        }
    });

    //mobile-tab-based-menu
    $(document).on('click', '.header__inner .shop-search-icon', function () {
        $('.header__callout').toggleClass('is-active');
    });

    if ($(window).width() < 768) {
        $(document).on('click', '.mobile-footer-menu-group-heading', function (e) {
            e.preventDefault();
            if ($(this).hasClass('active')) {
                $('.mobile-footer-menu-wrapper .mobile-footer-menu, .mobile-footer-menu-group-heading').removeClass('active');
            }
            else {
                $('.mobile-footer-menu-wrapper .mobile-footer-menu, .mobile-footer-menu-group-heading').removeClass('active');
                $(this).closest('.mobile-footer-menu-group-heading').next('.mobile-footer-menu').addClass('active');
                $(this).addClass('active');
            }
        });
    }

    // Gorgias - Use this script to customize the chat button.
    var initGorgiasChatPromise = (window.GorgiasChat) ? window.GorgiasChat.init() : new Promise(function (resolve) { window.addEventListener('gorgias-widget-loaded', function () { resolve();})});
    var screenSize = window.matchMedia("(max-width: 767px)");

    initGorgiasChatPromise.then(function () {
        console.log('gorgias style init load..')

        var timer = setInterval(function () {
            var chatButtonHead = document.querySelector('#gorgias-chat-container')?.querySelector('#chat-button')?.contentWindow.document.querySelector('head');
            if (!chatButtonHead || ![...chatButtonHead?.children].some(x => x.getAttribute("data-emotion"))) {
                return;
            }
            clearInterval(timer);

            var buttonStyle = document.createElement('style');
            // the custom CSS for the chat button
            if (screenSize.matches) { // mobile screen has different iframe
                buttonStyle.textContent = '#mountHere span {white-space: nowrap; overflow: hidden; max-width: 35px; padding-left: 4px; transition-duration: 0.6s; margin-left: 20px;}';
            }else{
                buttonStyle.textContent = '#mountHere span {white-space: nowrap; overflow: hidden; max-width: 35px; padding-left: 4px; transition-duration: 0.6s; margin-left: 20px;}';
            }
            chatButtonHead.appendChild(buttonStyle);
            console.log('gorgias style loaded!')
        }, 50);
    })

});


$(window).on('load', function () {
    //account-page-notification
    if ($(".account_header_full_banner .btn-full").length > 0) {
        var noti_product_count = $(".account_header_full_banner .btn-full").attr("data-notifcation");
        var current_noti_product = $('.chapter-' + noti_product_count + ' .account-meet-product-item .product-item__head h5');
        $(".account_header_full_banner .btn-full").html('<span>You’ll be tasting ' + current_noti_product[0].innerText + '  in 3 boxes time.</span>');
    }
});

//add-cart-sticky-bar
$(document).on('change', 'input#sticky-quantity', function (e) {
    var stictyqtyVal = $(this).val();
    $('#quantity').val(stictyqtyVal);
});

$(document).on('click', '.sticky-plus-btn', function (e) {
    var qtyVal = parseInt($('#quantity').val());
    $('.js-quantity-plus').trigger("click");
    $('#sticky-quantity').val(qtyVal + 1);
});

$(document).on('click', '.sticky-minus-btn', function (e) {
    var qtyVal = parseInt($('#quantity').val());
    $('#sticky-quantity').val(qtyVal - 1);
    $('.js-quantity-minus').trigger("click");
});

$(document).on('click', '#sticky-add-to-cart', function (e) {
    $('.form__foot').find('.form__btn').trigger("click");
});

$(document).ready(function () {
    var totalPrice = 0;
    $(".bottel-product-content").find(".product-weight-val").each(function () {
        totalPrice += parseFloat($(this).html());
    });
    $('#total-value').text(totalPrice);
});


$('#subscription_pro, #gift_save_pro').on('click', function (e) {
    $(this).addClass('active-box');
    $('#gift_subscription_pro').removeClass('active-box');
});
$('#gift_subscription_pro').on('click', function (e) {
    $(this).addClass('active-box');
    $('#subscription_pro').removeClass('active-box');
});
$('.mfp-close').on('click', function (e) {
    //console.log('close- popup......');
    setTimeout(function () {
        $('html').removeClass('scroll_close');
    }, 100);
});
// $("input:radio[value='explorer'][name='productRedio']").prop('checked',true);
$.each($('.subscription-product-popup').find('.gift-subscription-item'), function (index, value) {
    $(this).find('input:radio').change(function () {
        if (this.value == 'explorer') {
            $(this).parent().closest('.gift-subscription-item').addClass('explorer_item');
            $(this).parent().closest('.gift-subscription-item').removeClass('advenced_main_item');
        }
        else if (this.value == 'advanced') {
            $(this).parent().closest('.gift-subscription-item').removeClass('explorer_item');
            $(this).parent().closest('.gift-subscription-item').addClass('advenced_main_item');
        }
    });
});

/* copy of clipboard */
(function () {

    var area = document.createElement('textarea');
    document.body.appendChild(area);
    area.style.display = "none";

    var content = document.querySelectorAll('.js-content');
    var copy = document.querySelectorAll('.js-copy');

    for (var i = 0; i < copy.length; i++) {
        copyOnClick(i);
    }

    function copyOnClick(i) {
        copy[i].addEventListener('click', function () {
            area.style.display = "block";
            area.value = content[i].innerText;
            area.select();
            document.execCommand('copy');
            area.style.display = "none";

            var t = this;
            // t.innerHTML = 'Cop<span style="color: red;">ied</span>';
            t.innerHTML = "Copied " + "'" + area.value + "'";
        });
    }
})();

/* gift save popup */
$.each($('.gift-card-items').find('.gift-card-item'), function (index, value) {
    var variants_id = $(this).find('.bundle-add-to-cart').attr("data-variant");
    $(this).find('.bundle-add-to-cart').on('click', function (e) {
        var qty = $(this).parent().closest('.gift-card-item').find('.quantity__total').val();
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                quantity: qty,
                id: variants_id
            },
            async: false
        });
    });
});

/* Copy link */
var $temp = $("<input>");
var $url = $(location).attr('href');

$('.copy__link').on('click', function () {
    $("body").append($temp);
    $temp.val($url).select();
    document.execCommand("copy");
    $temp.remove();
    //$("p").text("URL copied!");
})

//collection-page-js
if (window.location.href.indexOf("/collections") > -1) {
    $('.readmore').click(function (event) {
        event.preventDefault();
        var descriptionFull = document.querySelector('.product-description-full');
        descriptionFull.style.display = 'block';
        var descriptionShort = document.querySelector('.product-description-short');
        descriptionShort.style.display = 'none';
    });
    $('.readless').click(function (event) {
        event.preventDefault();
        var descriptionFull = document.querySelector('.product-description-full');
        descriptionFull.style.display = 'none';
        var descriptionShort = document.querySelector('.product-description-short');
        descriptionShort.style.display = 'block';
    });
}

setTimeout(function () {
    $.each($('.ais-facets').find('.ais-facet-disjunctive'), function (index) {
        var bodyHeight = $(this).innerHeight();
        // console.log('bodyHeight',bodyHeight);
        if ($(window).width() > 767) {
            $(this).find('.ais-facet--header').addClass('js-accordion-head is-active-accordion');
            $(this).find('.filter-type').addClass('accordion__body');
        }
        if (bodyHeight > 200) {
            // console.log('test-area');
            $(this).find('.ais-RefinementList-list').addClass('overflow-scroll');
        }
    });
    $('.filter__close__mobile').on('click', function (e) {
        $('.mobile-clear-all-data').removeClass('mobile-clear-btn');
    });
    $.each($('.ais-facets').find('.ais-facet-slider'), function (index) {
        var className = $(this).attr('class').replaceAll(".", "-");
        // console.log('className',className);
        $(this).addClass(className);
        // hide the filters handles if they are at a same (0 or other) value
        var minRange = $(this).find('.rheostat-handle-lower').attr('aria-valuemin');
        var maxRange = $(this).find('.rheostat-handle-upper').attr('aria-valuemax');
        minRange = Math.trunc(minRange);
        maxRange = Math.trunc(maxRange);
        if(minRange == maxRange){
            $(this).hide();
        }else{
            $(this).show();
        }
    });

    
    // $.each($('.ais-facets').find('.ais-facet-slider .rheostat-handle'), function (index) {
    //     // hide the filters handles if they are at a same (0 or other) value
    //     this.addEventListener('click', function () {
    //         console.log('touchstart');
    //         $(this).find('.rheostat-tooltip').show();
    //         var minValueNow = $(this).find('.rheostat-handle-lower').attr('aria-valuenow');
    //         var maxValueNow = $(this).find('.rheostat-handle-upper').attr('aria-valuenow');
    //         minValueNow = Math.trunc(minValueNow);
    //         maxValueNow = Math.trunc(maxValueNow);
    //         console.log('range.......',minValueNow,maxValueNow);
    //     });

    // });



    var tagListLength = $(".ais-current-refined-values--list li").length;
    var taglistLengthCount = (tagListLength);
    $('.ais-facets-button').find('#tagCount').text(taglistLengthCount);
    $('.ais-facet-slider,.ais-facet-disjunctive').on('click', function (e) {
        var tagCount = ($(".ais-current-refined-values--list li").length + 1);
        $('.ais-facets-button').find('#tagCount').text(tagCount);
    });
    $('.ais-ClearRefinements-button').on('click', function (e) {
        var tagListLength = 0;
        $('.ais-facets-button').find('#tagCount').text(tagListLength);
    });
}, 500);


/** Algolia filters hidden when returning empty **/
setTimeout(function () {
    $.each($('.ais-facets').find('.ais-RefinementList--noRefinement'), function () {
        $(this).parents().closest('.facet-wrap').addClass(' hidden');
    });
}, 500);


//sidecart js
$(document).on('click', '.addtowishlistBtn', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var pro_Id = $(this).parent(".cart-remove-btns").find(".cart-delete-btn").attr('rel');
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: {
            quantity: 0,
            id: pro_Id
        },
        success: function (data) {
            $.ajax({
                type: 'GET',
                dataType: 'json',
                url: '/cart.json',
                success: function (cart) {
                    $('#side_cart').find('.no_data').hide();
                    if (cart.item_count < 1) {
                        $('#side_cart').find('.cart_footer').hide();
                        $('#side_cart').find('.no_data').show();
                        $('.empty-cart').text('Your cart is currently empty.');
                        $('.form__empty').removeClass('hidden');
                        $('.cart-grid ,.mobile-content,.form__head').hide();
                    }
                    var total_price = cart['total_price'] / 100;
                    $('#total-price .price, .carttotal__price .price').text('$' + total_price.toFixed(2));
                    $('#side_cart .cart__subtotal__price').text('$' + total_price.toFixed(2));
                    $('.side_cart span').text(cart.item_count);
                    $('.hidden-wishlist-btn').each(function () {
                        var wishlistItem = $(this).attr('data-variant-id');
                        if (pro_Id == wishlistItem) {
                            $(this).trigger("click");
                            $('.mfp-close').trigger("click");
                            $(this).parents('.items ,.cart-item').remove();
                        }
                    });
                }
            });
        }
    });
});

$(document).on('click', '.cart-delete-btn', function (e) {
    var $this = $(this);
    e.preventDefault();
    e.stopPropagation();
    var pro_Id = $(this).attr('rel');
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: {
            quantity: 0,
            id: pro_Id
        },
        success: function (data) {
            $('#side_cart').find('.no_data').hide();
            if (data.item_count < 1) {
                $('#side_cart').find('.cart_footer').hide();
                $('#side_cart').find('.no_data').show();
                $('.empty-cart').text('Your cart is currently empty.');
                $('.form__empty ').removeClass('hidden');
                $('.cart-grid ,.mobile-content,.form__head').hide();
            }

            var total_price = data['total_price'] / 100;
            $('.subtotal_wrapper .cart__subtotal__price').text('$' + total_price.toFixed(2));
            $('.side_cart span').text(data.item_count);
            $('.mfp-close').trigger("click");
            $('.hidden-delete-btn').each(function () {
                var deleteItem = $($this).parents('#side_cart').find('.trigger_popup_fricc').attr("data-variant");
                if (pro_Id == deleteItem) {
                    $(this).trigger("click");
                    $('.mfp-close').trigger("click");
                    $(this).parents('.items').remove();
                    $('#side_cart .update').trigger("click");
                }
            });
            $.ajax({
                type: 'GET',
                dataType: 'json',
                url: '/cart.json',
                success: function (cart) {
                    $('#side_cart').find('.no_data').hide();
                    if (cart.item_count < 1) {
                        $('#side_cart').find('.cart_footer').hide();
                        $('#side_cart').find('.no_data').show();
                        $('.empty-cart').text('Your cart is currently empty.');
                        $('.form__empty ').removeClass('hidden');
                        $('.cart-grid ,.mobile-content,.form__head').hide();
                    }

                    var total_price = cart['total_price'] / 100;
                    $('#total-price .price, .carttotal__price .price').text('$' + total_price.toFixed(2));
                    $('.side_cart span').text(cart.item_count);
                    $('.mfp-close').trigger("click");
                    $('.hidden-delete-btn').each(function () {
                        var deleteItem = $(this).attr('rel');
                        if (pro_Id == deleteItem) {
                            $(this).trigger("click");
                            $('.mfp-close').trigger("click");
                            $(this).parents('.items ,.cart-item').remove();
                            $('#side_cart .update').trigger("click");
                            setTimeout(function () {
                                $.fn.sideCartUpsellHeightChange();
                            }, 2000);
                        }
                    });
                }
            });
        }
    });
});

if ($(window).width() < 768) {
    if ($(".template-cart").length > 0) {
        $('.template-cart .cart-right-div').insertAfter('.template-cart .table--cart');
    }
}
if ($(window).width() < 768) {
    if ($(".template-cart").length > 0) {
        $('.template-cart .cart-right-div').insertAfter('.template-cart .table--cart');
    }
}

$(document).on('click', '.cart-buy-now-btn', function (e) {
    e.preventDefault();
    var variantid = parseInt($(this).attr('data-variant'));
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {
            quantity: 1,
            id: variantid
        },
        success: function (data) {

            var oldtotal = $("#side_cart .cart__subtotal__price").attr("data-total");
            var price = data.price;
            var vp = (price / 100).toFixed(2);
            var subtotal = (+oldtotal) + (+price);
            var newSubtotal = subtotal;
            var undoContent = '<div class="items" id="' + data.id + '" data-type="Full bottles"><div class="cart_image_wrapper"><div class="image cart_item">' +
                '<a href="' + data.url + '" class="cart__image"><img src="' + data.image + '" alt="' + data.title + '"></a></div></div>' +
                '<div class="cart_data_wrapper"><div class="cart-title-with-remove-button"><div class="name cart_item ">' +
                '<a href="' + data.url + '">' + data.title + '</a></div><a href="/cart/change?line=1&quantity=0" class="hidden hidden-delete-btn">' +
                '<button type="button" class="cart__close">remove</button></a>' +
                '<button data-with-epi="true" class="hidden hidden-wishlist-btn swym-button swym-add-to-wishlist-view-product product_' + data.id + '"' +
                'data-swaction="addToWishlist" data-product-id="' + data.id + '" data-variant-id="' + data.variant_id + '" data-product-url="' + data.url + '"></button>' +
                '<div class="product__members-popup"><a href="#cart-item-remove-popup" class="product__members-popup-btn" data-variant="' + data.variant_id + '">' +
                '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">' +
                '<path d="M3.33333 13.3333C3.33333 13.6869 3.47381 14.026 3.72386 14.2761C3.97391 14.5261 4.31304 14.6666 4.66667 14.6666H11.3333C11.687 14.6666 12.0261 14.5261 12.2761 14.2761C12.5262 14.026 12.6667 13.6869 12.6667 13.3333V5.33325H14V3.99992H11.3333V2.66659C11.3333 2.31296 11.1929 1.97382 10.9428 1.72378C10.6928 1.47373 10.3536 1.33325 10 1.33325H6C5.64638 1.33325 5.30724 1.47373 5.05719 1.72378C4.80714 1.97382 4.66667 2.31296 4.66667 2.66659V3.99992H2V5.33325H3.33333V13.3333ZM6 2.66659H10V3.99992H6V2.66659ZM5.33333 5.33325H11.3333V13.3333H4.66667V5.33325H5.33333Z" fill="#969696"></path>' +
                '<path d="M6 6.66675H7.33333V12.0001H6V6.66675ZM8.66667 6.66675H10V12.0001H8.66667V6.66675Z" fill="#969696"></path>' +
                '</svg></a></div><div id="cart-item-remove-popup"class="mfp-hide popup__default"><div class="popup-title text-center">Are you sure you want to remove this product?</div>' +
                '<div class="content"><p>Instead of deleting, you can add the product to your wishlist so you dont lose it and buy it later</p></div>' +
                '<div class="cart-remove-btns"><a href="/cart/change?line=1&quantity=0" rel="' + data.id + '" class="cart-delete-btn">' +
                '<button type="button" class="cart__close">delete</button></a><button class="add-wishlist-btn addtowishlistBtn" data-product-id="" data-variant="">add to wishlist</button></div></div></div>' +
                '<div class="cart-quantity-with-total"><div class="qty cart_item"><div class="spinner"><div class="min">-</div>' +
                '<input type="number" name="updates[]" id="updates_' + data.id + '" value="1" min="0" data-id="' + data.id + '" class="product_qty">' +
                '<div class="plus">+</div></div></div><div class="table__total total_price text-right cart_item" data-attr="Total">' +
                //'<del class="compare-price">'+Shopify.formatMoney(data.compare_at_price , Shopify.moneyFormat)+'</del>'+
                '<span class="price test-four-pillars-christmas-gin-2022-edition-700ml"> $' + vp + '</span></div></dv></div></div>';
            $(undoContent).insertAfter(".empty-cart");
            //$(".cart__subtotal__price").html(Shopify.formatMoney(newSubtotal, Shopify.moneyFormat));
            $('#side_cart .update').trigger("click");
            setTimeout(function () {
                $.fn.sideCartUpsellHeightChange();
            }, 2000);
            $.ajax({
                type: 'GET',
                dataType: 'jsonp',
                url: '/cart.json',
                success: function (cart) {
                    var item_count = cart['item_count'];
                    var total_price = cart['total_price'] / 100;
                    $('#total-price .price, .carttotal__price .price').text('$' + total_price.toFixed(2));
                    $('#side_cart .cart__subtotal__price').text('$' + total_price.toFixed(2));
                    $('.side_cart').find('span').text(item_count);
                    $("#table--cart").load(location.href + " #table--cart>*", "");
                }
            });
        }
    }).done(function () {
        setTimeout(function () {
            $(".trigger_popup_fricc").click(function () {
                $(this).parents("#side_cart").next(".hover_bkgr_fricc").show();
                var did = $(this).attr("data-variant");
                $(this).parents("#side_cart").next(".hover_bkgr_fricc").find(".cart-delete-btn").attr('rel', did);
                $.each($('#table--cart').find('.cart-item'), function (index, value) {
                    var hrefData = $(this).find('.hidden-delete-btn').attr('href');
                    var wishlistItem = $(this).find('.hidden-wishlist-btn').attr('data-product-id');
                    var dataVariantId = $(this).attr('data-variant');
                    $('.cart-delete-btn').attr('rel', dataVariantId);
                    $('.cart-delete-btn').attr('href', hrefData);
                    $('.add-wishlist-btn').attr('data-product-id', wishlistItem);
                    $('.add-wishlist-btn').attr('data-variant', dataVariantId);
                });
            });
            $('.hover_bkgr_fricc').click(function () {
                $('.hover_bkgr_fricc').hide();
            });
            $('.popupCloseButton').click(function () {
                $('.hover_bkgr_fricc').hide();
            });
        }, 2500);
        setTimeout(function () {
            $(".product__members-popup-btn").on('click', function () {
                $.fn.sideCartUpsellHeightChange();
                $.each($('#table--cart').find('.cart-item'), function (index, value) {
                    var hrefData = $(this).find('.hidden-delete-btn').attr('href');
                    var wishlistItem = $(this).find('.hidden-wishlist-btn').attr('data-product-id');
                    var dataVariantId = $(this).find('.product__members-popup-btn').attr('data-variant');
                    setTimeout(function () {
                        $('.cart-delete-btn').attr('rel', dataVariantId);
                        $('.cart-delete-btn').attr('href', hrefData);
                        $('.add-wishlist-btn').attr('data-product-id', wishlistItem);
                        $('.add-wishlist-btn').attr('data-variant', dataVariantId);
                    }, 1000);
                });
            });
        }, 2500);
    });
    $(this).parents(".sidecart-upsell-item").remove();
});


if ($(window).width() < 768) {
    if ($(".template-cart").length > 0) {
        $('.template-cart .cart-right-div').insertAfter('.template-cart .table--cart');
    }
}

$.each($('.table--cart').find('.cart-item'), function (index, value) {
    var hrefData = $(this).find('.hidden-delete-btn').attr('href');
    var wishlistItem = $(this).find('.hidden-wishlist-btn').attr('data-product-id');
    $(this).find('.product__members-popup-btn').on('click', function (e) {
        var dataVariantId = $(this).attr('data-variant');
        $('.cart-delete-btn').attr('rel', dataVariantId);
        $('.cart-delete-btn').attr('href', hrefData);
        // var datawishlistItem = $(this).attr('data-product-id');
        // $('.add-wishlist-btn').attr('rdata-product-id', wishlistItem);
        $('.add-wishlist-btn').attr('data-product-id', wishlistItem);
        $('.add-wishlist-btn').attr('data-variant', dataVariantId);
    });
});
$(document).on('click', '.cart-recommendations-product  .cart-buy-now-btn', function (e) {
    e.preventDefault();
    // console.log('test-area....');
    //   var qty = $('#quantity').val();
    var variantid = parseInt($(this).attr('data-variant'));
    var cartAjaxUrl = "/cart/add.js";

    jQuery.post(
        cartAjaxUrl,
        {
            quantity: 1,
            id: variantid
        },
        null,
        "json"
    )
        .done(function (cart) {
            location.href = "/cart";
            $('.side_cart').find('span').text(cart.item_count);
        })
        .fail(function (jqxhr, textStatus, error) {
            //console.log("ERROR: " + textStatus + " " + error);
        });
});
$(document).on('click', '.sidecart-recommendations-product .cart-buy-now-btn', function (e) {
    e.preventDefault();
    var variantid = parseInt($(this).attr('data-variant'));
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {
            quantity: 1,
            id: variantid
        },
        success: function (data) {
            $.ajax({
                type: 'GET',
                dataType: 'jsonp',
                url: '/cart.json',
                success: function (cart) {
                    var item_count = cart['item_count'];
                    var total_price = cart['total_price'] / 100;
                    $('#total-price .price, .carttotal__price .price').text('$' + total_price.toFixed(2));
                    $('#side_cart .cart__subtotal__price').text('$' + total_price.toFixed(2));
                    $('.side_cart').find('span').text(item_count);
                    $("#table--cart").load(location.href + " #table--cart>*", "");
                }
            });
        }
    }).done(function () {
        setTimeout(function () {
            $.fn.sideCartUpsellHeightChange();
            $.each($('#table--cart').find('.cart-item'), function (index, value) {
                var hrefData = $(this).find('.hidden-delete-btn').attr('href');
                var wishlistItem = $(this).find('.hidden-wishlist-btn').attr('data-product-id');
                var dataVariantId = $(this).find('.product__members-popup-btn').attr('data-variant');
                $('.cart-delete-btn').attr('rel', dataVariantId);
                $('.cart-delete-btn').attr('href', hrefData);
                $('.add-wishlist-btn').attr('data-product-id', wishlistItem);
                $('.add-wishlist-btn').attr('data-variant', dataVariantId);
            });
        }, 2500);
    });
});
//currency js
$('.shopify-currency-form select').on('change', function () {
    $(this)
        .parents('form')
        .submit();
});

//search page
$('.search-page-collection').hide();

$(document).ready(function () {
    setTimeout(function () {
        var pageURL = window.location.pathname;
        if (pageURL == '/search') {
            var searchResult = $('.ais-stats-container-search').find('.ais-Stats-text').text().replace('for ‘’', '');
            $('.ais-stats-container-search').find('.ais-Stats-text').text(searchResult);

            var input = $('.ais-SearchBox-input');
            var searchValue = input.val();
            var defaultText = $('.ais-stats-container-search .ais-Stats').find('span').html();
            var updatedText = defaultText.replace('No results for ‘' + searchValue + '’', 'No results for ‘' + searchValue + '’. <span class="no-result-text"> Don’t give up! Check the spelling, or try something less specific. Alternatively, get inspired below:</span>');

            $('.ais-stats-container-search .ais-Stats span').html(updatedText);
            var clearData = $('.clear-stats-container').find('.ais-Stats-text').text();


            if (clearData == 'No items selected') {
                $('.template-search ').find('.filter-wrapper').hide();
                $('.search-page-collection').show();
            } else {
                $('.template-search ').find('.filter-wrapper').show();
                $('.search-page-collection').hide();
            }
        }

    }, 500);


    var input = $('.ais-SearchBox-input');
    var typingTimer;
    var doneTypingInterval = 100; // Trigger the request 1 second/1000 ms after user done typing.

    input.on('keyup', function () {
        clearTimeout(typingTimer);
        typingTimer = setTimeout(doneTyping, doneTypingInterval);
    });

    input.on('keydown', function () {
        clearTimeout(typingTimer);
    });

    function doneTyping() {
        let searchValue = $('.ais-SearchBox-input').val();
        var params = new window.URLSearchParams(window.location.search);
        var paramsVal = params.get('q');

        if (paramsVal == null) {
            var searchResult = $('.ais-stats-container-search').find('.ais-Stats-text').text().replace('for ‘’', '');
            // console.log(pageURL ,searchResult);
            $('.ais-stats-container-search').find('.ais-Stats-text').text(searchResult);
        }

        $('.ais-stats-container-search .ais-Stats span').html($('.ais-stats-container-search .ais-Stats span').html().replace('No results for ‘' + searchValue + '’', 'No results for ‘' + searchValue + '’. <span class="no-result-text"> Don’t give up! Check the spelling, or try something less specific. Alternatively, get inspired below:</span>'));
        var clearData = $('.clear-stats-container').find('.ais-Stats-text').text();
        //console.log('test-search-value',clearData);

        if (clearData == 'No items selected') {
            $('.template-search ').find('.filter-wrapper').hide();
            $('.search-page-collection').show();
        } else {
            $('.template-search ').find('.filter-wrapper').show();
            $('.search-page-collection').hide();
        }
    }

    (function () {

        var area = document.createElement('textarea');
        document.body.appendChild(area);
        area.style.display = "none";

        var content = document.querySelectorAll('.column-block__code span');
        var copy = document.querySelectorAll('.copy_code');

        for (var i = 0; i < copy.length; i++) {
            copyOnClick(i);
        }

        function copyOnClick(i) {
            copy[i].addEventListener('click', function () {
                area.style.display = "block";
                area.value = content[i].innerText;
                area.select();
                document.execCommand('copy');
                alert("Coupon code copied");
            });
        }
    })();

});

if (window.location.href.indexOf("/wishlist") > -1) {
    //wishlist page
    $(document).ready(function () {
        //setInterval(wishListLoad(),1000);
        var interval = setInterval(wishListLoad, 500);
        function wishListLoad() {
            if ($('#wishlist-items-container').children().length > 0) {
                console.log('Clear intreval trigger');
                clearInterval(interval);
                $(".loader").hide();

                $(".wishlist-product-wrapper tfoot").append('<tr class="wishlist-add-all-cart"><td></td></tr>');
                if ($(".template-page--swym").length > 0) {
                    $('.template-page--swym #add-all-to-cart').insertAfter('.template-page--swym .wishlist-add-all-cart td');
                    $('.template-page--swym .add-all-to-cart-error').insertBefore('.template-page--swym .wishlist-add-all-cart td');
                }
                var trLength = jQuery('#wishlist-items-container>.wishlist-product-wrapper>tbody>tr').length;
                //console.log('trLength',trLength);
                if (trLength > 0) {
                    $('#wishlist-items-container').closest('.section-wishlist').find('#wishlist-items-count').text(trLength + ' items');
                    //console.log('row count',trLength);
                }
            }
        }
    });
}

$(document).ready(function () {

    // changing the height of sidecart upsell depending of the screen
    $.fn.sideCartUpsellHeightChange = function () {
        //$.fn.updateCartUI();
        var sidecartHeight = $('.sidecart-upsell-items').outerHeight();
        if (sidecartHeight > 0 && sidecartHeight < 250) {
            $('#side_cart').find('.cart_data').addClass('heightchange');
            $('#side_cart').find('.cart_data').removeClass('full-height');
        } else if (sidecartHeight == 0) {
            $('#side_cart').find('.cart_data').removeClass('heightchange');
            $('#side_cart').find('.cart_data').addClass('full-height');
        } else {
            $('#side_cart').find('.cart_data').removeClass('heightchange');
            $('#side_cart').find('.cart_data').removeClass('full-height');
        }
        var sidecart_data = $('#side_cart').find('.cart_data').outerHeight();
        //console.log('bodyHeight',sidecartHeight);
        if (sidecartHeight > 320) {
            $('#side_cart').find('.cart_data').addClass('side-overflow-scroll');
        } else if (sidecartHeight < 319) {
            $('#side_cart').find('.cart_data').removeClass('side-overflow-scroll');
        } else {
            $('#side_cart').find('.cart_data').removeClass('side-overflow-scroll');
        }
    }

    //sidecart 2nd product height based js
    $.fn.sideCartUpsellSecondProductHideShow = function () {
        var currentHeight = $('#side_cart').innerHeight();
        if (currentHeight < 840) {
            $('#side_cart').find('.sidecart-upsell-item').last().hide();
        } else {
            $('#side_cart').find('.sidecart-upsell-item').last().show();
        }
    }
    $('.side_cart').on('click', function (e) {
        $.fn.sideCartUpsellSecondProductHideShow();
    });
});
$(window).resize(function () {
    var currentHeight = $('#side_cart').innerHeight();
    //console.log("set current height on load 2 = " + currentHeight);
    if (currentHeight < 840) {
        $('#side_cart').find('.sidecart-upsell-item').last().hide();
    } else {
        $('#side_cart').find('.sidecart-upsell-item').last().show();
    }
});
//sidecart height based js
$(document).ready(function () {
    $("#myBtn").on('click', function () {
        $(this).hide();
        $("#dots").hide();
        $("#more").css("display", "inline");
    });
    $("#additionalBtn").on("click", function () {
        $(this).hide();
        $(".membership-select-product, .section-home-video, .fathers-day-quote, #additionalBtn2").show();
    });
    $("#additionalBtn2").on("click", function () {
        $(this).hide();
        $("#additionalBtn").show();
        $(".membership-select-product, .section-home-video, .fathers-day-quote").hide();
    });
    /* setTimeout(function() {
        var discountCode = Cookies.get("discount_code");
        var inputVal = $('.cart-right-div').find('.dcodeInnerWrapper #dcodeInput').val();
        $('.cart-right-div').find('#dcodeOuterWrapper #dcodeInput').val(discountCode);
        $('#dcodeSubmit').trigger('click');
    }, 2500); */
});


//cart membership
$.each($('.table--cart').find('.cart-item'), function (index, value) {
    var member_per = $(this).find('.membership_percentage').text().replace('%', '');
    if (member_per != NaN) {
        var cart_price = $(this).find('.table__total .price').text().replace('$', '');
        var price_mul = (member_per * cart_price) / 100;
        $(this).find('.total-memberprice').text(price_mul);
        //console.log('memberprice persantage',member_per,cart_price,price_mul);
    }
});
var totalval = 0;
$('.total-memberprice').each(function () {
    var value = $(this).text() != "" ? parseFloat($(this).text()) : 0;
    totalval += value;
    var mem_price_zero = totalval.toFixed(2);
    $("#member-total-price").text(totalval.toFixed(2));
    $('.cart_subscribe__subtitle').closest('.section-membership-items').find('.memberprice').text('$' + totalval.toFixed(2));
    //console.log('total price',mem_price_zero);
    if (mem_price_zero == 0) {
        $('.cart_subscribe__subtitle').closest('.section-membership-items').find('.hide-save-price').hide();
    } else {
        $('.cart_subscribe__subtitle').closest('.section-membership-items').find('.hide-save-price').show();
    }
});

if ($('.template-article').length) {
    $(document).ready(function () {
        var relatedarticleLength = $('.section-trending-articles').find('.swiper-slide').length;
        if (relatedarticleLength == 0) {
            $('.section-trending-articles').hide();
        } else {
            $('.section-trending-articles').show();
        }
    });
}

$(window).on('load', function () {
    $('.popup__advent_content .content').hide();
    $('.advent-show-me').on('click', function (e) {
        $('.popup__advent_content .content-grinch').hide();
        $('.popup__advent_content .content').show();
    });
});

/*Hide the footer on mobile when an element is "focus"
UX: avoid having a squeezed screen with keyboard and footer overlapping */
var screenSize = window.matchMedia("(max-width: 767px)");
var input = document.getElementsByClassName("form__text-focus");
var footer = document.getElementById("section-subscription-gift-message__footer");

if (screenSize.matches) {
    for (var i = 0; i < input.length; i++) {
        input[i].addEventListener("focusin", function () {
            footer.style.position = "inherit";
        });
        input[i].addEventListener("focusout", function () {
            footer.style.position = "fixed";
        });
    }
}





// ////
// //when coming from Back button (Browser) - reloading page
// window.addEventListener( "pageshow", function ( event ) {
//     var historyTraversal = event.persisted ||
//                             ( typeof window.performance != "undefined" &&
//                                 window.performance.navigation.type === 2 );
//     if ( historyTraversal ) {
//         console.log('coming from back button - Removing GC.')

//         if (window.location.href.indexOf("/cart") > -1) {
//             // Remove the GiftCard from cart
//             if ($('#table--cart').find('#'+'7269987844144').length) {
//                 var line_item_id = $('#'+'7269987844144').attr('line_item_number');
//                 console.log('Removing gift card line item number: ' + line_item_id)
//                 $.ajax({
//                     type: 'POST',
//                     url: '/cart/change.js',
//                     dataType: 'json',
//                     data: {
//                         line: line_item_id,
//                         quantity: 0
//                     },
//                     success: function (data) {
//                         $.ajax({
//                             type: 'GET',
//                             dataType: 'json',
//                             url: '/cart.json',
//                             success: function (cart) {
//                                 $('#side_cart').find('#'+'7269987844144').hide();
//                                 $('#side_cart').find('.no_data').hide();
//                                 if (cart.item_count < 1) {
//                                     $('#side_cart').find('.cart_footer').hide();
//                                     $('#side_cart').find('.no_data').show();
//                                     $('.empty-cart').text('Your cart is currently empty.');
//                                     $('.form__empty').removeClass('hidden');
//                                     $('.cart-grid ,.mobile-content,.form__head').hide();
//                                 }
//                             }
//                         });
//                         location.reload(true);
//                     }
//                 });
//             }
//         }else{
//             // Remove the GiftCard from cart
//             if ($('#side_cart').find('#'+'7269987844144').length) {
//                 var line_item_id = $('#'+'7269987844144').attr('line_item_number');
//                 console.log('Removing gift card line item number: ' + line_item_id)
//                 $.ajax({
//                     type: 'POST',
//                     url: '/cart/change.js',
//                     dataType: 'json',
//                     data: {
//                         line: line_item_id,
//                         quantity: 0
//                     },
//                     success: function (data) {
//                         $.ajax({
//                             type: 'GET',
//                             dataType: 'json',
//                             url: '/cart.json',
//                             success: function (cart) {
//                                 $('#side_cart').find('#'+'7269987844144').hide();
//                                 $('#side_cart').find('.no_data').hide();
//                                 if (cart.item_count < 1) {
//                                     $('#side_cart').find('.cart_footer').hide();
//                                     $('#side_cart').find('.no_data').show();
//                                     $('.empty-cart').text('Your cart is currently empty.');
//                                     $('.form__empty').removeClass('hidden');
//                                     $('.cart-grid ,.mobile-content,.form__head').hide();
//                                 }
//                             }
//                         });
//                     }
//                 });
//             }
//         }
//         // Handle page restore.
//         //window.location.reload();
//     }
//     });
///////////
////

// Function to update the cart UI - adding product by TIER $$$
// $.fn.updateCartUI = function () {
//     $(document).ready(function() {
//         // Code to be executed once the DOM has finished loading
//         console.log("LAUNCHING updateCartUI")

//         let hasRedemption = false;
//         //check if contain redemption products
//         if ($('#side_cart').find('#'+6820377100336).length || $('#side_cart').find('#'+6995406323760).length || $('#side_cart').find('#'+6820377722928).length ||
//             $('#side_cart').find('#'+6822321094704).length || $('#side_cart').find('#'+6820377034800).length || $('#side_cart').find('#'+6995406192688).length ||
//             $('#side_cart').find('#'+6820377657392).length || $('#side_cart').find('#'+6822320930864).length || $('#side_cart').find('#'+6820377067568).length ||
//             $('#side_cart').find('#'+6995406094384).length || $('#side_cart').find('#'+6820377690160).length || $('#side_cart').find('#'+6822320996400).length
//         ) {
//             console.log('Redemption in cart, do not add the auto gift product')
//             hasRedemption = true;
//         }

//         // Get the current total price of the cart if exist
//         if ($('.table__finaltotal-value').length && hasRedemption == false) {
//             var targetTotal = document.getElementsByClassName("table__finaltotal-value")[0].getElementsByClassName("price")[0].textContent;
//             targetTotal = targetTotal.replace("$", "");
//             var switchNumber = 0;
//             console.log('targetTotal = ', targetTotal);

//             // Remove the price if product is in the cart
//             if ($('#side_cart').find('#'+7212621889584).length || $('#side_cart').find('#'+7212621692976).length || $('#side_cart').find('#'+7212621430832).length ) {
//                 if($('#side_cart').find('#'+7212621430832).length){
//                     priceToTarget = $('#side_cart').find('#'+7212621430832 + ' .table__total .price').text().replace('$', '');
//                 }else if($('#side_cart').find('#'+7212621692976).length){
//                     priceToTarget = $('#side_cart').find('#'+7212621692976 + ' .table__total .price').text().replace('$', '');
//                 }else if($('#side_cart').find('#'+7212621889584).length){
//                     priceToTarget = $('#side_cart').find('#'+7212621889584 + ' .table__total .price').text().replace('$', '');
//                 }

//                 console.log('priceToTarget = ',priceToTarget)
//                 targetTotal = targetTotal - priceToTarget;
//                 console.log('targetTotal - Remove price = ', targetTotal);
//             }

//             switch (true) {
//             case targetTotal >= 600:
//                 var variantId = 40804405411888;
//                 var productId = 7212621889584;
//                 var switchNumber = 3;
//                 break;
//             case targetTotal >= 300:
//                 var variantId = 40804405149744
//                 var productId = 7212621692976;
//                 var switchNumber = 2;
//                 break;
//             case targetTotal >= 150:
//                 var variantId = 40804404854832
//                 var productId = 7212621430832;
//                 var switchNumber = 1;
//                 break;
//             default:
//                 // no product added
//             }


//             if(switchNumber == 1 || switchNumber == 2 || switchNumber == 3){
//                 console.log(switchNumber, 'switchNumber')
//                 switch (true) {
//                     case switchNumber == 1:
//                     var productIdToRemove01 = 7212621889584;
//                     var variantIdToRemove01 = 40804405411888
//                     var productIdToRemove02 = 7212621692976;
//                     var variantIdToRemove02 = 40804405149744
//                     console.log("switch 01 " + variantIdToRemove01 + ' ' + variantIdToRemove02)
//                     break;
//                     case switchNumber == 2:
//                     var productIdToRemove01 = 7212621430832;
//                     var variantIdToRemove01 = 40804404854832
//                     var productIdToRemove02 = 7212621889584;
//                     var variantIdToRemove02 = 40804405411888;
//                     console.log("switch 02 " + variantIdToRemove01 + ' ' + variantIdToRemove02)
//                     break;
//                     case switchNumber == 3:
//                     var productIdToRemove01 = 7212621430832;
//                     var variantIdToRemove01 = 40804404854832;
//                     var productIdToRemove02 = 7212621692976;
//                     var variantIdToRemove02 = 40804405149744
//                     console.log("switch 03 " + variantIdToRemove01 + ' ' + variantIdToRemove02)
//                     break;
//                     default:
//                     // no product added
//                     console.log(variantIdToRemove01 + ' ' + variantIdToRemove02)
//                 }

//             }

//             if ($('#side_cart').find('#'+productId).length) {
//                 // The element with id "#productId" exists within the element with id "side_cart" - do nothing
//                 console.log('Already found in cart')

//             } else {

//                 // The element with id "12345" does not exist within the element with id "side_cart"


//                 $.ajax({
//                     type: 'POST',
//                     url: '/cart/add.js',
//                     dataType: 'json',
//                     data: {
//                     quantity: 1,
//                     id: variantId
//                     },
//                     success: function (data) {

//                         var oldtotal = $("#side_cart .cart__subtotal__price").attr("data-total");
//                         var price = data.price;
//                         var vp = (price / 100).toFixed(2);
//                         var subtotal = (+oldtotal) + (+price);
//                         var newSubtotal = subtotal;
//                         var undoContent = '<div class="items" id="' + data.id + '" data-type="Full bottles"><div class="cart_image_wrapper"><div class="image cart_item">' +
//                             '<a href="' + data.url + '" class="cart__image"><img src="' + data.image + '" alt="' + data.title + '"></a></div></div>' +
//                             '<div class="cart_data_wrapper"><div class="cart-title-with-remove-button"><div class="name cart_item ">' +
//                             '<a href="' + data.url + '">' + data.title + '</a></div><a href="/cart/change?line=1&quantity=0" class="hidden hidden-delete-btn">' +
//                             '<button type="button" class="cart__close">remove</button></a>' +
//                             '<button data-with-epi="true" class="hidden hidden-wishlist-btn swym-button swym-add-to-wishlist-view-product product_' + data.id + '"' +
//                             'data-swaction="addToWishlist" data-product-id="' + data.id + '" data-variant-id="' + data.variant_id + '" data-product-url="' + data.url + '"></button>' +
//                             '<div class="product__members-popup"><a href="#cart-item-remove-popup" class="product__members-popup-btn" data-variant="' + data.variant_id + '">' +
//                             '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">' +
//                             '<path d="M3.33333 13.3333C3.33333 13.6869 3.47381 14.026 3.72386 14.2761C3.97391 14.5261 4.31304 14.6666 4.66667 14.6666H11.3333C11.687 14.6666 12.0261 14.5261 12.2761 14.2761C12.5262 14.026 12.6667 13.6869 12.6667 13.3333V5.33325H14V3.99992H11.3333V2.66659C11.3333 2.31296 11.1929 1.97382 10.9428 1.72378C10.6928 1.47373 10.3536 1.33325 10 1.33325H6C5.64638 1.33325 5.30724 1.47373 5.05719 1.72378C4.80714 1.97382 4.66667 2.31296 4.66667 2.66659V3.99992H2V5.33325H3.33333V13.3333ZM6 2.66659H10V3.99992H6V2.66659ZM5.33333 5.33325H11.3333V13.3333H4.66667V5.33325H5.33333Z" fill="#969696"></path>' +
//                             '<path d="M6 6.66675H7.33333V12.0001H6V6.66675ZM8.66667 6.66675H10V12.0001H8.66667V6.66675Z" fill="#969696"></path>' +
//                             '</svg></a></div><div id="cart-item-remove-popup"class="mfp-hide popup__default"><div class="popup-title text-center">Are you sure you want to remove this product?</div>' +
//                             '<div class="content"><p>Instead of deleting, you can add the product to your wishlist so you dont lose it and buy it later</p></div>' +
//                             '<div class="cart-remove-btns"><a href="/cart/change?line=1&quantity=0" rel="' + data.id + '" class="cart-delete-btn">' +
//                             '<button type="button" class="cart__close">delete</button></a><button class="add-wishlist-btn addtowishlistBtn" data-product-id="" data-variant="">add to wishlist</button></div></div></div>' +
//                             '<div class="cart-quantity-with-total"><div class="qty cart_item"><div class="spinner"><div class="min">-</div>' +
//                             '<input type="number" name="updates[]" id="updates_' + data.id + '" value="1" min="0" data-id="' + data.id + '" class="product_qty">' +
//                             '<div class="plus">+</div></div></div><div class="table__total total_price text-right cart_item" data-attr="Total">' +
//                             //'<del class="compare-price">'+Shopify.formatMoney(data.compare_at_price , Shopify.moneyFormat)+'</del>'+
//                             '<span class="price test-four-pillars-christmas-gin-2022-edition-700ml"> $' + vp + '</span></div></dv></div></div>';
//                         $(undoContent).insertAfter(".empty-cart");
//                         //$(".cart__subtotal__price").html(Shopify.formatMoney(newSubtotal, Shopify.moneyFormat));
//                         $('#side_cart .update').trigger("click");
//                         $.ajax({
//                             type: 'GET',
//                             dataType: 'jsonp',
//                             url: '/cart.json',
//                             success: function (cart) {
//                                 var item_count = cart['item_count'];
//                                 var total_price = cart['total_price'] / 100;
//                                 $('#total-price .price, .carttotal__price .price').text('$' + total_price.toFixed(2));
//                                 $('#side_cart .cart__subtotal__price').text('$' + total_price.toFixed(2));
//                                 $('.side_cart').find('span').text(item_count);
//                                 $("#table--cart").load(location.href + " #table--cart>*", "");
//                             }
//                         });
//                     }
//                 }).done(function () {
//                     setTimeout(function () {
//                         $(".trigger_popup_fricc").click(function () {
//                             $(this).parents("#side_cart").next(".hover_bkgr_fricc").show();
//                             var did = $(this).attr("data-variant");
//                             $(this).parents("#side_cart").next(".hover_bkgr_fricc").find(".cart-delete-btn").attr('rel', did);
//                             $.each($('#table--cart').find('.cart-item'), function (index, value) {
//                                 var hrefData = $(this).find('.hidden-delete-btn').attr('href');
//                                 var wishlistItem = $(this).find('.hidden-wishlist-btn').attr('data-product-id');
//                                 var dataVariantId = $(this).attr('data-variant');
//                                 $('.cart-delete-btn').attr('rel', dataVariantId);
//                                 $('.cart-delete-btn').attr('href', hrefData);
//                                 $('.add-wishlist-btn').attr('data-product-id', wishlistItem);
//                                 $('.add-wishlist-btn').attr('data-variant', dataVariantId);
//                             });
//                         });
//                         $('.hover_bkgr_fricc').click(function () {
//                             $('.hover_bkgr_fricc').hide();
//                         });
//                         $('.popupCloseButton').click(function () {
//                             $('.hover_bkgr_fricc').hide();
//                         });
//                         if ($('#side_cart').find('#'+productIdToRemove01).length) {
//                             var line_item_id = $('#'+productIdToRemove01).attr('line_item_number');
//                             console.log('variant to remove 01 ' + variantIdToRemove01 + " line item id " + line_item_id)
//                             $.ajax({
//                                 type: 'POST',
//                                 url: '/cart/change.js',
//                                 dataType: 'json',
//                                 data: {
//                                     line: line_item_id,
//                                     quantity: 0
//                                 },
//                                 success: function (data) {
//                                     console.log('variant removed 01 ' + variantIdToRemove01)
//                                     $.ajax({
//                                         type: 'GET',
//                                         dataType: 'json',
//                                         url: '/cart.json',
//                                         success: function (data) {
//                                             $.ajax({
//                                                 type: 'GET',
//                                                 dataType: 'json',
//                                                 url: '/cart.json',
//                                                 success: function (cart) {
//                                                     $('#side_cart').find('.no_data').hide();
//                                                     if (cart.item_count < 1) {
//                                                         $('#side_cart').find('.cart_footer').hide();
//                                                         $('#side_cart').find('.no_data').show();
//                                                         $('.empty-cart').text('Your cart is currently empty.');
//                                                         $('.form__empty').removeClass('hidden');
//                                                         $('.cart-grid ,.mobile-content,.form__head').hide();
//                                                     }
//                                                     var total_price = cart['total_price'] / 100;
//                                                     $('#total-price .price, .carttotal__price .price').text('$' + total_price.toFixed(2));
//                                                     $('#side_cart .cart__subtotal__price').text('$' + total_price.toFixed(2));
//                                                     $('.side_cart span').text(cart.item_count);
//                                                     $('.hidden-wishlist-btn').each(function () {
//                                                         var wishlistItem = $(this).attr('data-variant-id');
//                                                         if (variantIdToRemove01 == wishlistItem) {
//                                                             $(this).parents('.items ,.cart-item').remove();
//                                                         }
//                                                     });
//                                                 }
//                                             });
//                                         }
//                                     });
//                                 }
//                             });
//                         }
//                         if ($('#side_cart').find('#'+productIdToRemove02).length) {
//                             var line_item_id = $('#'+productIdToRemove02).attr('line_item_number');
//                             console.log('variant to remove 02 ' + variantIdToRemove02 + " line item id " + line_item_id)
//                             $.ajax({
//                                 type: 'POST',
//                                 url: '/cart/change.js',
//                                 dataType: 'json',
//                                 data: {
//                                     line: line_item_id,
//                                     quantity: 0
//                                 },
//                                 success: function (data) {
//                                     $.ajax({
//                                         type: 'GET',
//                                         dataType: 'json',
//                                         url: '/cart.json',
//                                         success: function (cart) {
//                                             $('#side_cart').find('.no_data').hide();
//                                             if (cart.item_count < 1) {
//                                                 $('#side_cart').find('.cart_footer').hide();
//                                                 $('#side_cart').find('.no_data').show();
//                                                 $('.empty-cart').text('Your cart is currently empty.');
//                                                 $('.form__empty').removeClass('hidden');
//                                                 $('.cart-grid ,.mobile-content,.form__head').hide();
//                                             }
//                                             var total_price = cart['total_price'] / 100;
//                                             $('#total-price .price, .carttotal__price .price').text('$' + total_price.toFixed(2));
//                                             $('#side_cart .cart__subtotal__price').text('$' + total_price.toFixed(2));
//                                             $('.side_cart span').text(cart.item_count);
//                                             $('.hidden-wishlist-btn').each(function () {
//                                                 var wishlistItem = $(this).attr('data-variant-id');
//                                                 if (variantIdToRemove02 == wishlistItem) {

//                                                     $(this).parents('.items ,.cart-item').remove();
//                                                 }
//                                             });
//                                         }
//                                     });
//                                 }
//                             });
//                         }

//                         //force reload if its cart page as cart page is not showing updated cart
//                         if (window.location.href.indexOf("/cart") > -1) {
//                             location.reload(true);
//                         }

//                     }, 2500);
//                     setTimeout(function () {
//                         $(".product__members-popup-btn").on('click', function () {
//                             $.each($('#table--cart').find('.cart-item'), function (index, value) {
//                                 var hrefData = $(this).find('.hidden-delete-btn').attr('href');
//                                 var wishlistItem = $(this).find('.hidden-wishlist-btn').attr('data-product-id');
//                                 var dataVariantId = $(this).find('.product__members-popup-btn').attr('data-variant');
//                                 setTimeout(function () {
//                                     $('.cart-delete-btn').attr('rel', dataVariantId);
//                                     $('.cart-delete-btn').attr('href', hrefData);
//                                     $('.add-wishlist-btn').attr('data-product-id', wishlistItem);
//                                     $('.add-wishlist-btn').attr('data-variant', dataVariantId);
//                                 }, 1000);
//                             });
//                         });

//                     }, 2500);
//                 });
//             }
//         }
//     });
// }